import React, { Component, createRef } from "react";
import {
  AlertCircle,
  Clock,
  User,
  CheckCircle,
  MessageCircle,
} from "lucide-react";
import axios from "axios";
import TbChestForm from "../Reportingbotform/tbchest";
import XrayChest from "../Reportingbotform/xraychest";
import XrayKnee from "../Reportingbotform/xrayknee";
import XRayShoulderForm from "../Reportingbotform/xrayrightshoulder";
import XRayLeftShoulderForm from "../Reportingbotform/xrayleftshoulder";
import XRaySpineForm from "../Reportingbotform/xrayspinecervical";
import XRaySpineDorsalForm from "../Reportingbotform/xrayspinedorsal";
import { generateBlankReport } from "../../utils/blanksexport";
// import XrayChest from "../../utils/xraychestform";
import BlankForm from "../Reportingbotform/blank";
//import for new forms 
import CtAbdomenForm from "../Reportingbotform/CtAbdomenForm";
import CtHeadForm from "../Reportingbotform/CtHeadForm";
import CtPnsForm from "../Reportingbotform/CtPnsForm";
import "../doctor/Viewer.css";
import "../doctor/Viewer.css";
import { FiFile } from "react-icons/fi"; // File icon from react-icons
import html2canvas from "html2canvas";
import { API_BASE_URL } from "../Api/apiconnector";
import { X } from "lucide-react";
import jsPDF from "jspdf";
import "jspdf-autotable";

import * as cornerstone from "@cornerstonejs/core";
import * as cornerstoneTools from "@cornerstonejs/tools";
import cornerstoneDICOMImageLoader from "@cornerstonejs/dicom-image-loader";
import {
  cornerstoneStreamingImageVolumeLoader,
  cornerstoneStreamingDynamicImageVolumeLoader,
} from "@cornerstonejs/streaming-image-volume-loader";
import dicomParser from "dicom-parser";
import createImageIdsAndCacheMetaData from "../../utils/createImageIdsAndCacheMetaData";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import ReportEditorModule from "./ReportEditor";
// Toolgroup and rendering setup
const toolGroupId = "myToolGroup";
const renderingEngineId = "myRenderingEngine";
const viewportIds = ["first", "second", "third", "fourth"];
const indexMap = {
  first: "viewport1Index",
  second: "viewport2Index",
  third: "viewport3Index",
  fourth: "viewport4Index",
};

const Tools = {
  Length: cornerstoneTools.LengthTool,
  Angle: cornerstoneTools.AngleTool,
  CobbAngle: cornerstoneTools.CobbAngleTool,
  RectangleROI: cornerstoneTools.RectangleROITool,
  CircleROI: cornerstoneTools.CircleROITool,
  EllipticalROI: cornerstoneTools.EllipticalROITool,
  FreehandROI: cornerstoneTools.PlanarFreehandROITool,
  Bidirectional: cornerstoneTools.BidirectionalTool,
  Zoom: cornerstoneTools.ZoomTool,
  Pan: cornerstoneTools.PanTool,
  Contrast: cornerstoneTools.WindowLevelTool,
  Probe: cornerstoneTools.ProbeTool,
  Eraser: cornerstoneTools.EraserTool,
  PlanarRotate: cornerstoneTools.PlanarRotateTool,
  Height: cornerstoneTools.HeightTool,
  SplineROI: cornerstoneTools.SplineROITool,
  StackScroll: cornerstoneTools.StackScrollMouseWheelTool,
  ArrowAnnotate: cornerstoneTools.ArrowAnnotateTool,
  Crosshairs: cornerstoneTools.CrosshairsTool,
  Magnify: cornerstoneTools.MagnifyTool,
  Wheel: cornerstoneTools.StackScrollTool,
  ReferenceLines: cornerstoneTools.ReferenceLinesTool,
};
const BODY_PART_TEMPLATE_MAP = {
  "KUB USA":"EXAM: X-RAY KUB",
  "ABDOMEN USA": "EXAM: X-RAY ABDOMEN",
  "ABDOMEN SERIES USA": "EXAM: X-RAY ABDOMEN",

  "CHEST USA": "EXAM: X-RAY CHEST",
  "CHEST PA USA": "EXAM: X-RAY CHEST",
  "CHEST AP USA": "EXAM: X-RAY CHEST",
  "CHEST & ABDOMEN USA": "EXAM: X-RAY CHEST",
  "CHEST + ABDOMEN USA": "EXAM: X-RAY CHEST",

  "CERVICAL SPINE USA": "EXAM: X-RAY CERVICAL SPINE",
  "CERVICAL SPINE FLEX EXT USA":
  "EXAM: X-RAY CERVICAL SPINE WITH FLEXION EXTENSION",

  "THORACIC SPINE USA": "EXAM: X-RAY THORACIC SPINE",
  "LUMBAR SPINE USA": "EXAM: X-RAY LUMBAR SPINE",
  "LUMBAR SPINE FLEX EXT USA":
  "EXAM: X-RAY LUMBAR SPINE WITH FLEXION EXTENSION",

  "WHOLE SPINE USA": "EXAM: X-RAY WHOLE SPINE FOR SCOLIOSIS",
  "AC JOINT USA ": "EXAM: X-RAY ACROMIOCLAVICULAR JOINT - BILATERAL",
  "SC JOINT USA": "EXAM: X-RAY STERNO CLAVICULAR JOINT - BILATERAL",
  "TMJ USA": "EXAM: X-RAY TMJ BILATERAL",

  "SHOULDER LEFT": "EXAM: X-RAY SHOULDER - LEFT",
  "SHOULDER RIGHT": "EXAM: X-RAY SHOULDER - RIGHT",
  "SHOULDER BILATERAL": "EXAM: X-RAY SHOULDER - BILATERAL",

  "ELBOW LEFT": "EXAM: X-RAY ELBOW - LEFT",
  "ELBOW RIGHT": "EXAM: X-RAY ELBOW - RIGHT",
  "ELBOW BILATERAL": "EXAM: X-RAY ELBOW - BILATERAL",

  "WRIST LEFT": "EXAM: X-RAY WRIST JOINT - LEFT",
  "WRIST RIGHT": "EXAM: X-RAY WRIST JOINT - RIGHT",
  "WRIST BILATERAL": "EXAM: X-RAY WRIST JOINT - BILATERAL",

  "HAND LEFT": "EXAM: X-RAY HAND - LEFT",
  "HAND RIGHT": "EXAM: X-RAY HAND - RIGHT",
  "HAND BILATERAL": "EXAM: X-RAY HAND - BILATERAL",

  "HIP LEFT": "EXAM: X-RAY HIP JOINT - LEFT",
  "HIP RIGHT": "EXAM: X-RAY HIP JOINT - RIGHT",
  "HIP BILATERAL": "EXAM: X-RAY HIP JOINT - BILATERAL",

  "KNEE LEFT": "EXAM: X-RAY KNEE - LEFT",
  "KNEE RIGHT": "EXAM: X-RAY KNEE - RIGHT",
  "KNEE BILATERAL": "EXAM: X-RAY KNEE - BILATERAL",

  "ANKLE LEFT": "EXAM: X-RAY ANKLE JOINT - LEFT",
  "ANKLE RIGHT": "EXAM: X-RAY ANKLE JOINT - RIGHT",
  "ANKLE BILATERAL": "EXAM: X-RAY ANKLE JOINT - BILATERAL",

  "FOOT LEFT": "EXAM: X-RAY FOOT - LEFT",
  "FOOT RIGHT": "EXAM: X-RAY FOOT - RIGHT",
  "FOOT BILATERAL": "EXAM: X-RAY FOOT - BILATERAL",
  
  "TOE LEFT": "EXAM: X-RAY TOE - LEFT",
  "TOE RIGHT": "EXAM: X-RAY TOE - RIGHT",
  "TOE BILATERAL": "EXAM: X-RAY TOE - BILATERAL",

  "FINGER LEFT": "EXAM: X-RAY FINGER - LEFT",
  "FINGER RIGHT": "EXAM: X-RAY FINGER - RIGHT",
  "FINGER BILATERAL": "EXAM: X-RAY FINGER - BILATERAL",

  "LEG LEFT": "EXAM: X-RAY LEG - LEFT",
  "LEG RIGHT": "EXAM: X-RAY LEG - RIGHT",
  "LEG BILATERAL": "EXAM: X-RAY LEG - BILATERAL",


  "PELVIS USA": "EXAM: X-RAY PELVIS",
  "SACRUM USA": "EXAM: X-RAY SACRUM",
  "RIBS USA": "EXAM: X-RAY RIBS",
  "SKULL USA": "EXAM: X-RAY SKULL",
  "MANDIBLE USA": "MANDIBLE",
  "MASTOID USA": "MASTOIDS",
  "BONE SURVEY USA": "BONE SURVEY",
  "FACE + PNS USA": "EXAM: X-RAY FACE AND PARANASAL SINUSES",
  "FACE AND PARANASAL SINUSES USA": "EXAM: X-RAY FACE AND PARANASAL SINUSES",
  "PNS":"EXAM: X-RAY FACE AND PARANASAL SINUSES",
  "NOSE":"EXAM: X-RAY FACE AND PARANASAL SINUSES",
  "BONE AGE": "	EXAM: X-RAY BONE AGE",
};

const CT_TEMPLATE_MAP = {
  "HEAD WITHOUT CONTRAST USA": "CT BRAIN WITHOUT CONTRAST",
  "LUMBAR SPINE WITHOUT CONTRAST USA": "CT LUMBAR SPINE WITHOUT CONTRAST",
  "CERVICAL SPINE WITHOUT CONTRAST USA": "CT CERVICAL SPINE WITHOUT CONTRAST",
  "THORACIC SPINE WITHOUT CONTRAST USA": "CT THORACIC SPINE WITHOUT CONTRAST",
  "SINUS WITHOUT CONTRAST USA": "CT SINUSES WITHOUT CONTRAST",
  "SINUS WITH AND WITHOUT CONTRAST USA": "CT SINUSES WITH AND WITHOUT CONTRAST",
  "LUNG CANCER SCREENING USA": "CT CHEST LOW-DOSE LUNG SCREENING WITHOUT CONTRAST",
  "CHEST WITH CONTRAST USA": "CT CHEST WITH CONTRAST",
  "CHEST WITHOUT CONTRAST USA": "CT CHEST WITHOUT CONTRAST",
  "CHEST WITH AND WITHOUT CONTRAST USA": "CT CHEST WITH AND WITHOUT CONTRAST",
  "ABDOMEN WITH AND WITHOUT CONTRAST USA": "CT ABDOMEN WITH AND WITHOUT CONTRAST",
  "ABDOMEN & PELVIS WITHOUT CONTRAST USA": "CT ABDOMEN AND PELVIS WITHOUT CONTRAST",
  "ABDOMEN & PELVIS WITH CONTRAST USA": "CT ABDOMEN AND PELVIS WITH CONTRAST",
  "KNEE WITHOUT CONTRAST (RIGHT) USA": "CT RIGHT KNEE WITHOUT CONTRAST",
  "CT SINUS FUSION USA": "CT SINUS",
  // No template in your list: "CT SINUS FUSION USA", "CTA HEAD AND NECK WITH CONTRAST USA"
};

const MR_TEMPLATE_MAP = {
  "BRAIN WITHOUT CONTRAST USA": "MRI BRAIN WITHOUT CONTRAST",
  "HEAD WITHOUT CONTRAST USA": "MRI BRAIN WITHOUT CONTRAST",
  "BRAIN WITH AND WITHOUT CONTRAST USA": "MRI BRAIN WITH AND WITHOUT CONTRAST",
  "BRAIN & IAC WITH AND WITHOUT CONTRAST USA": "MRI BRAIN WITH IACS WITH AND WITHOUT CONTRAST",
  "BRAIN & IAC WITH AND WITHOUT CONTRAST PLUS USA": "MRI BRAIN WITH IACS WITH AND WITHOUT CONTRAST",
  "BRAIN & PITUITARY WITH AND WITHOUT CONTRAST USA": "MRI PITUITARY WITH AND WITHOUT CONTRAST", // check: or MRI BRAIN WITH AND WITHOUT CONTRAST
  "CERVICAL SPINE WITHOUT CONTRAST USA": "MRI CERVICAL SPINE WITHOUT CONTRAST",
  "CERVICAL SPINE WITH AND WITHOUT CONTRAST USA": "MRI CERVICAL SPINE WITHOUT CONTRAST", // no with/without template exists
  "THORACIC SPINE WITHOUT CONTRAST USA": "MRI THORACIC SPINE WITHOUT CONTRAST",
  "THORACIC SPINE WITH AND WITHOUT CONTRAST USA": "MRI THORACIC SPINE WITH AND WITHOUT CONTRAST",
  "LUMBAR SPINE WITH AND WITHOUT CONTRAST USA": "MRI LUMBAR SPINE WITH AND WITHOUT CONTRAST",
  "TEMPOROMANDIBULAR JOINTS WITHOUT CONTRAST USA": "MRI TEMPOROMANDIBULAR JOINTS WITHOUT CONTRAST",
  "SACRUM COCCYX WITHOUT CONTRAST USA": "MRI SACRUM/COCCYX WITHOUT CONTRAST",
  "SHOULDER WITHOUT CONTRAST (RIGHT) USA": "MRI RIGHT SHOULDER WITHOUT CONTRAST",
  "SHOULDER WITHOUT CONTRAST (LEFT) USA": "MRI LEFT SHOULDER WITHOUT CONTRAST",
  "KNEE WITHOUT CONTRAST (RIGHT) USA": "MRI RIGHT KNEE WITHOUT CONTRAST",
  "ABDOMEN WITHOUT CONTRAST W/MRCP USA": "MRI ABDOMEN WITH MRCP WITHOUT CONTRAST",
  "PELVIS WITH AND WITHOUT CONTRAST USA": "MRI PELVIS WITH AND WITHOUT CONTRAST",
  // No template in your list: "MRA NECK ...", "MRA HEAD ...", "ORBIT,FACE,NECK WITH AND WITHOUT CONTRAST USA"
};

const MODALITY_TEMPLATE_MAPS = {
  XR: BODY_PART_TEMPLATE_MAP,
  CT: CT_TEMPLATE_MAP,
  MR: MR_TEMPLATE_MAP,
};



class Viewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      options_label: "DEFAULT",
      showDetails: true,
      status: "under-reporting",
      showReportEditor: false,
      studyData: null,
      cornerstoneInitialized: false,
      patientData: null,
      loading: true,
      error: null,
      currentUser: null, // Add this line
      reportFrmData: this.props.editorData || "",
      // ✅ ADD THESE - They were missing
      splitterPosition: 50,
      isResizing: false,
      drafts: [],
      selectedDraftId: "",
      services: [], // list fetched from backend
      selectedService: "", // currently selected service
      showTbChestForm: false,
      showXRayChestForm: false,
      showBlankForm: false,
      showXRayKneeForm: false,
      showXRayShoulderForm: false,
      showXRayLeftShoulderForm: false,
      showXRaySpineDorsalForm: false,
      showXRaySpineForm: false,
      didEditorLoadDraft: false,
      draftFetchComplete: false,
      draftExists: false,
      showCtAbdomenForm: false,
      showCtPnsForm: false,
      showCtHeadForm: false,
    };

    this.renderingEngineRef = createRef();

    this.splitterRef = createRef(); // ✅ Add this ref
    // Initialize instance variables
    this.toolGroup = null;
    this.renderingEngine = null;
    this.viewport_list = {};
    this.selected_viewport = null;
    this.prev_selected_element = null;
    this.nonCT_ImageIds = [];
    this.curr_tool = null;
    this.prev_layout = "one";
    this.eventListeners = [];
    this.cornerstoneProcessed = false;

    this.cornerstone = this.cornerstone.bind(this);
    this.drop = this.drop.bind(this);
    this.allowDrop = this.allowDrop.bind(this);
    this.toggleTool = this.toggleTool.bind(this);
    this.volumeOrientation = this.volumeOrientation.bind(this);
    this.slabThickness = this.slabThickness.bind(this);
    this.slab = this.slab.bind(this);
    this.orientationSettings = this.orientationSettings.bind(this);
    this.viewportSettings = this.viewportSettings.bind(this);
    this.layoutSettings = this.layoutSettings.bind(this);
    this.openImageInViewport = this.openImageInViewport.bind(this);
    this.toggleInvert = this.toggleInvert.bind(this);
    this.downloadAsJPEG = this.downloadAsJPEG.bind(this);
    this.capture = this.capture.bind(this);
    // ✅ Bind the new methods
    this.startResize = this.startResize.bind(this);
    this.closeReportEditor = this.closeReportEditor.bind(this);
    this.windowingSettings = this.windowingSettings.bind(this);
    this.getPresignedUrl = this.getPresignedUrl.bind(this);
    this.FrontendTBReport = this.FrontendTBReport.bind(this);
    this.totalImageCount = 0;
  }

  fetchCurrentUser = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/current_user/`, {
        withCredentials: true,
      });
      this.setState({ currentUser: response.data });
    } catch (err) {
      console.error("Error fetching current user:", err);
    }
  };

  async fetchPatientData() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const patientId = urlParams.get("id");

      if (!patientId) throw new Error("No patient ID provided in URL");

      const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: patientId }),
      });

      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const data = await response.json();
      console.log("📋 Patient Data from API:", data);

      // ✅ Store DICOM ID in state
      this.setState({
        patientData: data,
        dicomId: data.id, // 👈 Add this line
        loading: false,
      });

      return data;
    } catch (error) {
      console.error("Error fetching patient data:", error);
      this.setState({ error: error.message, loading: false });
      return null;
    }
  }

 



  cleanPatientId = (id) => {
  if (!id) return id;
  return id.replace(/-\d{1,2}$/, "");
};

  downloadAsJPEG(element) {
  const { patientData } = this.state;

  if (!element) {
    console.error("No element provided to downloadAsJPEG");
    return;
  }

  const patientName = (patientData && patientData.patient_name) || "unknown_patient";
  const patientId = this.cleanPatientId(
    (patientData && patientData.patient_id) || "unknown_id"
  );
  const sex = (patientData && patientData.gender) || "";
  const age = (patientData && patientData.age) || "";
  const studyDate = (patientData && patientData.study_date) || "";

  html2canvas(element, { allowTaint: true, scale: 1 }).then((rawCanvas) => {
    // ---------------------------------------------------------
    // 1️⃣ Detect actual X-ray bounds (skip black margins AND red border)
    // ---------------------------------------------------------
    const rawCtx = rawCanvas.getContext("2d");
    const { width, height } = rawCanvas;
    const imageData = rawCtx.getImageData(0, 0, width, height).data;

    const BRIGHTNESS_THRESHOLD = 30;

    const isRealContent = (x, y) => {
      const idx = (y * width + x) * 4;
      const r = imageData[idx];
      const g = imageData[idx + 1];
      const b = imageData[idx + 2];
      const avg = (r + g + b) / 3;
      const isReddish = r > g + 35 && r > b + 35;
      return avg > BRIGHTNESS_THRESHOLD && !isReddish;
    };

    // --- Horizontal bounds (left/right) ---
    const sampleRows = [
      Math.floor(height * 0.4),
      Math.floor(height * 0.5),
      Math.floor(height * 0.6),
    ];

    let left = null;
    let right = null;

    for (let x = 0; x < width; x++) {
      const hit = sampleRows.some((y) => isRealContent(x, y));
      if (hit) {
        if (left === null) left = x;
        right = x;
      }
    }

    const cropWidth = left !== null ? right - left : 0;
    const finalLeft = cropWidth > width * 0.2 ? left : 0;
    const finalWidth = cropWidth > width * 0.2 ? cropWidth : width;

    // --- Vertical bounds (top/bottom) ---
    const sampleCols = [
      finalLeft + Math.floor(finalWidth * 0.4),
      finalLeft + Math.floor(finalWidth * 0.5),
      finalLeft + Math.floor(finalWidth * 0.6),
    ];

    let top = null;
    let bottom = null;

    for (let y = 0; y < height; y++) {
      const hit = sampleCols.some((x) => isRealContent(x, y));
      if (hit) {
        if (top === null) top = y;
        bottom = y;
      }
    }

    const cropHeight = top !== null ? bottom - top : 0;
    const finalTop = cropHeight > height * 0.2 ? top : 0;
    const finalHeight = cropHeight > height * 0.2 ? cropHeight : height;

    // ---------------------------------------------------------
    // 2️⃣ Draw cropped region onto a new canvas
    // ---------------------------------------------------------
    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = finalWidth;
    croppedCanvas.height = finalHeight;
    const ctx = croppedCanvas.getContext("2d");

    ctx.drawImage(
      rawCanvas,
      finalLeft, finalTop, finalWidth, finalHeight, // source rect
      0, 0, finalWidth, finalHeight                  // dest rect
    );

    // ---------------------------------------------------------
    // 3️⃣ Overlay patient info onto the cropped image
    // ---------------------------------------------------------
    const lines = [
      `Patient ID : ${patientId}`,
      `Patient Name : ${patientName}`,
      `Sex : ${sex}`,
      `Age : ${age}`,
      `Study Date : ${studyDate}`,
    ];

    const fontSize = Math.max(14, Math.round(finalWidth * 0.02));
    const lineHeight = fontSize * 1.4;
    const paddingLeft = 15;
    const paddingBottom = 15;

    ctx.save();
    ctx.textAlign = "left";
    ctx.direction = "ltr";
    ctx.textBaseline = "bottom";
    ctx.font = `${fontSize}px monospace`;

    const totalHeight = lines.length * lineHeight;
    const startY = croppedCanvas.height - paddingBottom - totalHeight + lineHeight;

    lines.forEach((line, index) => {
      const y = startY + index * lineHeight;
      ctx.lineWidth = 3;
      ctx.strokeStyle = "rgba(0,0,0,0.9)";
      ctx.strokeText(line, paddingLeft, y);
      ctx.fillStyle = "#e5e5e5";
      ctx.fillText(line, paddingLeft, y);
    });

    ctx.restore();

    // ---------------------------------------------------------
    // 4️⃣ Export
    // ---------------------------------------------------------
    const jpegImageUrl = croppedCanvas.toDataURL("image/jpeg");

    const sanitizedPatientName = patientName
      .replace(/[^a-z0-9]/gi, "_")
      .toLowerCase();
    const sanitizedPatientId = patientId
      .replace(/[^a-z0-9]/gi, "_")
      .toLowerCase();

    const link = document.createElement("a");
    link.href = jpegImageUrl;
    link.download = `${sanitizedPatientId}_${sanitizedPatientName}.jpeg`;
    link.click();
  });
}

  capture(element) {
    html2canvas(element, { allowTaint: true }).then(function (canvas) {
      const imageUrl = canvas.toDataURL("image/png");

      if (window.editor) {
        window.editor.model.change((writer) => {
          const root = window.editor.model.document.getRoot();
          const endPosition = writer.createPositionAt(root, "end");

          // ✅ set fixed width and height
          const imageElement = writer.createElement("imageBlock", {
            src: imageUrl,
            alt: "Captured Screenshot",
            width: "600px", // fixed width
            height: "400px", // fixed height
          });

          writer.insert(imageElement, endPosition);
        });

        console.log("✅ Image inserted successfully!");
      } else {
        console.error("❌ CKEditor instance not found.");
      }
    });
  }

  toggleDetails = () => {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails,
    }));
  };

  allowDrop(event) {
    event.preventDefault();
  }

  async openImageInViewport(ID, modality, targetViewportId) {
    try {
      let viewport = this.renderingEngine.getViewport(targetViewportId);

      // If viewport doesn't exist, enable it first
      if (!viewport) {
        const viewportConfig = this.viewport_list[targetViewportId];
        if (viewportConfig) {
          this.renderingEngine.enableElement(viewportConfig);
          viewport = this.renderingEngine.getViewport(targetViewportId);
        } else {
          console.error(
            `Viewport ${targetViewportId} not found in viewport_list`
          );
          return;
        }
      }

      if (!viewport) {
        console.error(
          `Viewport ${targetViewportId} is not properly initialized`
        );
        return;
      }

      if (viewport.type === cornerstone.Enums.ViewportType.VOLUME) {
        viewport.setVolumes([]);
      }

      if (modality === "CT" || modality === "MR") {
        const volume = cornerstone.cache.getVolume(ID);
        if (!volume) {
          console.error(`Volume ${ID} not found in cache`);
          return;
        }

        const hasMultipleSlices = volume && volume.imageIds.length > 1;

        if (hasMultipleSlices) {
          const newViewport =
            await cornerstone.utilities.convertStackToVolumeViewport({
              options: {
                volumeId: ID,
                viewportId: targetViewportId,
                orientation: cornerstone.Enums.OrientationAxis.ACQUISITION,
              },
              viewport: viewport,
            });

          newViewport.setProperties({ rotation: 0 });

          if (this.toolGroup) {
            try {
              this.toolGroup.addViewport(newViewport.id, renderingEngineId);
            } catch (e) {
              // Ignore if already exists
            }
          }

          newViewport.render();

          const newImageListener = () => {
            const index = newViewport.getSliceIndex() + 1;
            const indexElement = document.getElementById(
              indexMap[newViewport.id]
            );
            if (indexElement) {
              indexElement.innerHTML = "Image: " + index;
            }
          };

          newViewport.element.addEventListener(
            cornerstone.EVENTS.VOLUME_NEW_IMAGE,
            newImageListener
          );
          this.eventListeners.push({
            element: newViewport.element,
            type: cornerstone.EVENTS.VOLUME_NEW_IMAGE,
            listener: newImageListener,
          });
        } else {
          viewport.setStack(volume.imageIds);
          viewport.render();
        }
      } else {
        if (viewport.type === cornerstone.Enums.ViewportType.STACK) {
          const imageIds = this.nonCT_ImageIds[Number(ID)];
          if (imageIds) {
            viewport.setStack(imageIds);
            viewport.render();
          } else {
            console.error(`Non-CT image IDs not found for ID: ${ID}`);
          }
        } else {
          this.renderingEngine.disableElement(targetViewportId);
          let curr = this.viewport_list[targetViewportId];
          if (curr) {
            curr.type = cornerstone.Enums.ViewportType.STACK;
            delete curr.defaultOptions;

            this.renderingEngine.enableElement(curr);

            const newViewport =
              this.renderingEngine.getViewport(targetViewportId);
            if (newViewport) {
              newViewport.setProperties({ rotation: 0 });

              if (this.toolGroup) {
                try {
                  this.toolGroup.addViewport(newViewport.id, renderingEngineId);
                } catch (e) {
                  // Ignore if already exists
                }
              }

              const imageIds = this.nonCT_ImageIds[Number(ID)];
              if (imageIds) {
                newViewport.setStack(imageIds);
                newViewport.render();

                const newImageListener = () => {
                  const index = newViewport.getCurrentImageIdIndex() + 1;
                  const indexElement = document.getElementById(
                    indexMap[newViewport.id]
                  );
                  if (indexElement) {
                    indexElement.innerHTML = "Image: " + index;
                  }
                };

                newViewport.element.addEventListener(
                  cornerstone.EVENTS.STACK_NEW_IMAGE,
                  newImageListener
                );
                this.eventListeners.push({
                  element: newViewport.element,
                  type: cornerstone.EVENTS.STACK_NEW_IMAGE,
                  listener: newImageListener,
                });
              } else {
                console.error(`Non-CT image IDs not found for ID: ${ID}`);
              }
            }
          } else {
            console.error(
              `Viewport configuration not found for: ${targetViewportId}`
            );
          }
        }
      }
    } catch (error) {
      console.error("Error opening image in viewport:", error);
    }
  }

  drop(event) {
    event.preventDefault();

    // Get dropped item info
    const obj = JSON.parse(event.dataTransfer.getData("text"));
    const ID = obj[0];
    const modality = obj[1];

    // Get current viewport
    const parentElement = event.target.parentElement;
    const viewport_ID = parentElement.getAttribute("data-value");

    // Force a small delay to let React finish its updates
    setTimeout(() => {
      this.openImageInViewport(ID, modality, viewport_ID);
    }, 10);
  }

  // async cornerstone(PARAM) {
  //   try {
  //     const previewTab = document.getElementById("previewTab");
  //     if (!previewTab) {
  //       console.error("Preview tab element not found");
  //       return;
  //     }

  //     const studyid = PARAM;

  //     // Create a loading message div
  //     const loadingMessage = document.createElement("div");
  //     loadingMessage.id = "loadingMessage";
  //     loadingMessage.innerText = "Please wait, images are loading...";
  //     loadingMessage.style.position = "absolute";
  //     loadingMessage.style.top = "50%";
  //     loadingMessage.style.left = "50%";
  //     loadingMessage.style.transform = "translate(-50%, -50%)";
  //     loadingMessage.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
  //     loadingMessage.style.color = "#fff";
  //     loadingMessage.style.padding = "10px 20px";
  //     loadingMessage.style.borderRadius = "5px";
  //     loadingMessage.style.fontSize = "16px";
  //     loadingMessage.style.zIndex = "1000";
  //     loadingMessage.style.pointerEvents = "none";
  //     document.body.appendChild(loadingMessage);

  //     // Timeout for the loading message - 1 minute
  //     const loadingMessageTimeout = setTimeout(() => {
  //       const message = document.getElementById("loadingMessage");
  //       if (message) {
  //         document.body.removeChild(message);
  //       }
  //     }, 60000);

  //     // Use the patient data from state instead of fetching again
  //     const { patientData } = this.state;

  //     if (!patientData) {
  //       throw new Error("Patient data not available");
  //     }

  //     const { study_instance_uid } = patientData;

  //     // Since we don't have series data from the new API, we'll need to adapt
  //     // For now, let's assume we need to fetch series data separately or modify the API
  //     // This part needs to be adjusted based on your actual data structure
  //     const response = await fetch(`${API_BASE_URL}/serverdata/`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //       body: `studyid=${encodeURIComponent(studyid)}`,
  //     });

  //     if (!response.ok) throw new Error(`Server error: ${response.status}`);

  //     const data = await response.json();
  //     this.setState({ studyData: data });

  //     const { study_uid, series } = data;

  //     let k = 0;
  //     let imageIdIndex = 0;
  //     let loadedSeriesCount = 0;

  //     // Handle each series asynchronously
  //     const imagePromises = series.map(async (item, index) => {
  //       const startTime = Date.now();

  //       let imageId = await createImageIdsAndCacheMetaData({
  //         StudyInstanceUID: study_uid,
  //         SeriesInstanceUID: item[0],
  //         wadoRsRoot: "https://pacs.reportingbot.in/dicom-web",
  //          headers: {
  //           Authorization: "Basic " + btoa("admin:u4rad"),
  //         },

  //       });
  //       //       let imageId = await createImageIdsAndCacheMetaData({
  //       //         StudyInstanceUID: study_uid,
  //       //         SeriesInstanceUID: item[0],
  //       //         wadoRsRoot: "https://pacs.reportingbot.in/dicom-web",
  //       //          headers: {
  //       //            Authorization: basicAuth
  //       //         },
  //       //         withCredentials: true  // important for sending cookies/credentials in CORS
  //       //  });

  //       let imageCount = 0;
  //       if (Array.isArray(imageId)) {
  //         imageCount = imageId.length;
  //       }
  //       this.totalImageCount += imageCount;

  //       // Create wrapper container (card for image + text)
  //       const cardContainer = document.createElement("div");
  //       cardContainer.style.display = "flex";
  //       cardContainer.style.alignItems = "center";
  //       cardContainer.style.border = "2px solid #ef4444";
  //       cardContainer.style.borderRadius = "6px";
  //       cardContainer.style.padding = "6px";
  //       cardContainer.style.marginBottom = "8px";
  //       cardContainer.style.backgroundColor = "#1D1D1F";
  //       cardContainer.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
  //       cardContainer.style.cursor = "pointer";

  //       // Create image
  //       let image = document.createElement("img");
  //       image.src = item[3];
  //       image.style.height = "80px";
  //       image.style.width = "100px";
  //       image.style.borderRadius = "4px";
  //       image.style.border = "1px solid #444";
  //       image.style.marginRight = "10px";

  //       // Create text container (common for both CT/MR and non-CT)
  //       const textContainer = document.createElement("div");
  //       textContainer.style.flex = "1";
  //       textContainer.style.color = "#f1f1f1";
  //       textContainer.style.fontSize = "11px";
  //       textContainer.style.lineHeight = "1.4";
  //       textContainer.innerHTML = `
  //         <p style="margin:0;">
  //           <strong>${item[1]}</strong>
  //         </p>
  //         <p style="margin:0;">${item[2]}</p>
  //         <p style="margin:2px 0; font-size:10px; color:#bbb;">
  //           Image Count: <strong>${imageCount}</strong>
  //         </p>
  //       `;

  //       // Process based on modality type
  //       if (
  //         (item[1] === "CT" || item[1] === "MR") &&
  //         Array.isArray(imageId) &&
  //         imageId.length > 0
  //       ) {
  //         // Patch metadata for all frames to avoid vec3 errors
  //         imageId.forEach((id) => {
  //           const imagePlaneMeta = cornerstone.metaData.get(
  //             "imagePlaneModule",
  //             id
  //           );

  //           if (
  //             !imagePlaneMeta ||
  //             !Array.isArray(imagePlaneMeta.imageOrientationPatient)
  //           ) {
  //             cornerstone.metaData.addProvider((type, metaId) => {
  //               if (type !== "imagePlaneModule" || metaId !== id)
  //                 return undefined;

  //               return {
  //                 ...imagePlaneMeta,
  //                 imageOrientationPatient:
  //                   imagePlaneMeta?.imageOrientationPatient || [
  //                     1, 0, 0, 0, 1, 0,
  //                   ],
  //                 imagePositionPatient:
  //                   imagePlaneMeta?.imagePositionPatient || [0, 0, 0],
  //                 rowCosines: [1, 0, 0],
  //                 columnCosines: [0, 1, 0],
  //                 frameOfReferenceUID:
  //                   imagePlaneMeta?.frameOfReferenceUID ||
  //                   "1.2.840.10008.1.2.1.999999",
  //                 rows: imagePlaneMeta?.rows || 512,
  //                 columns: imagePlaneMeta?.columns || 512,
  //                 pixelSpacing: imagePlaneMeta?.pixelSpacing || [1.0, 1.0],
  //               };
  //             }, 1000);
  //           }
  //         });

  //         // Assign a unique volumeId
  //         let volumeId = "cornerstoneStreamingImageVolume: myVolume" + k;
  //         k += 1;
  //         image.dataset.value = volumeId;

  //         try {
  //           // Create and cache the volume safely
  //           let volume = await cornerstone.volumeLoader.createAndCacheVolume(
  //             volumeId,
  //             { imageIds: imageId }
  //           );
  //           cornerstone.utilities.cacheUtils.performCacheOptimizationForVolume(
  //             volumeId
  //           );
  //           // volume.load();
  //         } catch (err) {
  //           console.error("Error creating volume for series:", item, err);
  //           return; // skip this series if volume creation fails
  //         }

  //         image.dataset.modality = item[1];
  //         image.dataset.description = item[2];
  //         image.draggable = true;

  //         image.addEventListener("load", () => {
  //           loadedSeriesCount++;
  //         });
  //       } else {
  //         // Non-CT/MR processing
  //         this.nonCT_ImageIds.push(imageId);
  //         image.dataset.value = imageIdIndex;
  //         imageIdIndex += 1;

  //         image.dataset.modality = item[1];
  //         image.dataset.description = item[2];
  //         image.draggable = true;

  //         image.addEventListener("load", () => {
  //           loadedSeriesCount++;
  //         });
  //       }

  //       // Add click event listener (common for both types)
  //       const clickListener = (event) => {
  //         const ID = event.target.dataset.value;
  //         const modality = event.target.dataset.modality;
  //         const targetViewportId = this.selected_viewport;
  //         this.openImageInViewport(ID, modality, targetViewportId);
  //       };

  //       image.addEventListener("click", clickListener);
  //       this.eventListeners.push({
  //         element: image,
  //         type: "click",
  //         listener: clickListener,
  //       });

  //       // Append children to card container (ONCE for both types)
  //       cardContainer.appendChild(image);
  //       cardContainer.appendChild(textContainer);

  //       // Add the card to preview tab (SINGLE APPEND POINT)
  //       previewTab.appendChild(cardContainer);

  //       const endTime = Date.now();
  //       const elapsedTime = endTime - startTime;
  //       console.log(
  //         `Series ${index + 1} (modality: ${
  //           item[1]
  //         }): Load Time = ${elapsedTime} ms`
  //       );
  //       return item;
  //     });

  //     // Once all promises are resolved, proceed to cleanup
  //     Promise.all(imagePromises)
  //       .then(() => {
  //         clearTimeout(loadingMessageTimeout);
  //         const message = document.getElementById("loadingMessage");
  //         if (message) {
  //           document.body.removeChild(message);
  //         }
  //         const firstImage = previewTab.querySelector("img");
  //         if (firstImage) {
  //           const ID = firstImage.dataset.value;
  //           const modality = firstImage.dataset.modality;
  //           const targetViewportId = viewportIds[0];
  //           this.openImageInViewport(ID, modality, targetViewportId);
  //         }
  //       })
  //       .catch((error) => {
  //         clearTimeout(loadingMessageTimeout);
  //         const message = document.getElementById("loadingMessage");
  //         if (message) {
  //           document.body.removeChild(message);
  //         }
  //         console.error("Error while loading images:", error);
  //       });

  //     const dragStartListener = (event) => {
  //       if (event.target.tagName === "IMG") {
  //         const transferData = [
  //           event.target.dataset.value,
  //           event.target.dataset.modality,
  //           event.target.dataset.description,
  //         ];
  //         event.dataTransfer.setData("text", JSON.stringify(transferData));
  //       }
  //     };

  //     previewTab.addEventListener("dragstart", dragStartListener);
  //     this.eventListeners.push({
  //       element: previewTab,
  //       type: "dragstart",
  //       listener: dragStartListener,
  //     });
  //   } catch (error) {
  //     console.error(error);
  //     const message = document.getElementById("loadingMessage");
  //     if (message) {
  //       document.body.removeChild(message);
  //     }
  //   }
  // }

    async cornerstone(PARAM) {
    try {
      const previewTab = document.getElementById("previewTab");
      if (!previewTab) {
        console.error("Preview tab element not found");
        return;
      }

      const studyid = PARAM;

      // Create a loading message div
      const loadingMessage = document.createElement("div");
      loadingMessage.id = "loadingMessage";
      loadingMessage.innerText = "Please wait, images are loading...";
      loadingMessage.style.position = "absolute";
      loadingMessage.style.top = "50%";
      loadingMessage.style.left = "50%";
      loadingMessage.style.transform = "translate(-50%, -50%)";
      loadingMessage.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
      loadingMessage.style.color = "#fff";
      loadingMessage.style.padding = "10px 20px";
      loadingMessage.style.borderRadius = "5px";
      loadingMessage.style.fontSize = "16px";
      loadingMessage.style.zIndex = "1000";
      loadingMessage.style.pointerEvents = "none";
      document.body.appendChild(loadingMessage);

      // Timeout for the loading message - 1 minute
      const loadingMessageTimeout = setTimeout(() => {
        const message = document.getElementById("loadingMessage");
        if (message) {
          document.body.removeChild(message);
        }
      }, 60000);

      // Use the patient data from state instead of fetching again
      const { patientData } = this.state;

      if (!patientData) {
        throw new Error("Patient data not available");
      }

      const { study_instance_uid } = patientData;

      // Since we don't have series data from the new API, we'll need to adapt
      // For now, let's assume we need to fetch series data separately or modify the API
      // This part needs to be adjusted based on your actual data structure
      const response = await fetch(`${API_BASE_URL}/serverdata/`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `studyid=${encodeURIComponent(studyid)}`,
      });

      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const data = await response.json();
      this.setState({ studyData: data });

      const { study_uid, series } = data;

      let k = 0;
      let imageIdIndex = 0;
      let loadedSeriesCount = 0;

      // ---------------------------------------------------------------
      // DEFAULT GEOMETRY (only addition): fills missing metadata so
      // volume creation does not crash
      // ---------------------------------------------------------------
      if (!this.patchedPlaneMeta) this.patchedPlaneMeta = new Map();

      // Register ONCE, at higher priority than the real DICOM provider
      if (!this._geometryProviderAdded) {
        cornerstone.metaData.addProvider((type, imageId) => {
          if (type === "imagePlaneModule") {
            return this.patchedPlaneMeta.get(imageId);
          }
          return undefined;
        }, 20000);
        this._geometryProviderAdded = true;
      }

      const ensureGeometryDefaults = (ids) => {
        const metas = ids.map(
          (id) => cornerstone.metaData.get("imagePlaneModule", id) || {}
        );

        const isVec = (v, n) =>
          Array.isArray(v) &&
          v.length >= n &&
          v.slice(0, n).every((x) => Number.isFinite(Number(x)));

        const orient = metas.find((m) => isVec(m.imageOrientationPatient, 6))
          ?.imageOrientationPatient.map(Number) || [1, 0, 0, 0, 1, 0];

        const rowCosines = orient.slice(0, 3);
        const columnCosines = orient.slice(3, 6);

        const pixelSpacing = metas
          .find((m) => isVec(m.pixelSpacing, 2))
          ?.pixelSpacing.map(Number) || [1, 1];

        const sliceStep =
          Number(metas.find((m) => m.sliceThickness)?.sliceThickness) ||
          Number(
            metas.find((m) => m.spacingBetweenSlices)?.spacingBetweenSlices
          ) ||
          1;

        const frameOfReferenceUID =
          metas.find((m) => m.frameOfReferenceUID)?.frameOfReferenceUID ||
          "1.2.840.10008.1.2.1.999999";

        // Keep real positions only if all are present AND all unique
        const posKeys = metas.map((m) =>
          isVec(m.imagePositionPatient, 3)
            ? m.imagePositionPatient.map((v) => Number(v).toFixed(3)).join(",")
            : null
        );
        const positionsUsable =
          posKeys.every(Boolean) && new Set(posKeys).size === ids.length;

        ids.forEach((id, i) => {
          const m = metas[i];
          const pix = cornerstone.metaData.get("imagePixelModule", id) || {};

          this.patchedPlaneMeta.set(id, {
            ...m,
            imageOrientationPatient: orient,
            rowCosines,
            columnCosines,
            pixelSpacing,
            rowPixelSpacing: pixelSpacing[0],
            columnPixelSpacing: pixelSpacing[1],
            frameOfReferenceUID,
            rows: m.rows || pix.rows || 512,
            columns: m.columns || pix.columns || 512,
            imagePositionPatient: positionsUsable
              ? m.imagePositionPatient.map(Number)
              : [0, 0, i * sliceStep],
            sliceThickness: m.sliceThickness || sliceStep,
          });
        });
      };
      // ---------------------------------------------------------------

      // Handle each series asynchronously
      const imagePromises = series.map(async (item, index) => {
        const startTime = Date.now();

        let imageId = await createImageIdsAndCacheMetaData({
          StudyInstanceUID: study_uid,
          SeriesInstanceUID: item[0],
          wadoRsRoot: "https://pacs.reportingbot.in/dicom-web",
           headers: {
            Authorization: "Basic " + btoa("admin:u4rad"),
          },

        });

        let imageCount = 0;
        if (Array.isArray(imageId)) {
          imageCount = imageId.length;
        }
        this.totalImageCount += imageCount;

        // Create wrapper container (card for image + text)
        const cardContainer = document.createElement("div");
        cardContainer.style.display = "flex";
        cardContainer.style.alignItems = "center";
        cardContainer.style.border = "2px solid #ef4444";
        cardContainer.style.borderRadius = "6px";
        cardContainer.style.padding = "6px";
        cardContainer.style.marginBottom = "8px";
        cardContainer.style.backgroundColor = "#1D1D1F";
        cardContainer.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
        cardContainer.style.cursor = "pointer";

        // Create image
        let image = document.createElement("img");
        image.src = item[3];
        image.style.height = "80px";
        image.style.width = "100px";
        image.style.borderRadius = "4px";
        image.style.border = "1px solid #444";
        image.style.marginRight = "10px";

        // Create text container (common for both CT/MR and non-CT)
        const textContainer = document.createElement("div");
        textContainer.style.flex = "1";
        textContainer.style.color = "#f1f1f1";
        textContainer.style.fontSize = "11px";
        textContainer.style.lineHeight = "1.4";
        textContainer.innerHTML = `
          <p style="margin:0;">
            <strong>${item[1]}</strong>
          </p>
          <p style="margin:0;">${item[2]}</p>
          <p style="margin:2px 0; font-size:10px; color:#bbb;">
            Image Count: <strong>${imageCount}</strong>
          </p>
        `;

        // Process based on modality type
        if (
          (item[1] === "CT" || item[1] === "MR") &&
          Array.isArray(imageId) &&
          imageId.length > 0
        ) {
          // Fill missing geometry with defaults so volume creation won't crash
          ensureGeometryDefaults(imageId);

          // Assign a unique volumeId
          let volumeId = "cornerstoneStreamingImageVolume: myVolume" + k;
          k += 1;
          image.dataset.value = volumeId;

          try {
            // Create and cache the volume safely
            let volume = await cornerstone.volumeLoader.createAndCacheVolume(
              volumeId,
              { imageIds: imageId }
            );
            cornerstone.utilities.cacheUtils.performCacheOptimizationForVolume(
              volumeId
            );
            // volume.load();
          } catch (err) {
            console.error("Error creating volume for series:", item, err);
            return; // skip this series if volume creation fails
          }

          image.dataset.modality = item[1];
          image.dataset.description = item[2];
          image.draggable = true;

          image.addEventListener("load", () => {
            loadedSeriesCount++;
          });
        } else {
          // Non-CT/MR processing
          this.nonCT_ImageIds.push(imageId);
          image.dataset.value = imageIdIndex;
          imageIdIndex += 1;

          image.dataset.modality = item[1];
          image.dataset.description = item[2];
          image.draggable = true;

          image.addEventListener("load", () => {
            loadedSeriesCount++;
          });
        }

        // Add click event listener (common for both types)
        const clickListener = (event) => {
          const ID = event.target.dataset.value;
          const modality = event.target.dataset.modality;
          const targetViewportId = this.selected_viewport;
          this.openImageInViewport(ID, modality, targetViewportId);
        };

        image.addEventListener("click", clickListener);
        this.eventListeners.push({
          element: image,
          type: "click",
          listener: clickListener,
        });

        // Append children to card container (ONCE for both types)
        cardContainer.appendChild(image);
        cardContainer.appendChild(textContainer);

        // Add the card to preview tab (SINGLE APPEND POINT)
        previewTab.appendChild(cardContainer);

        const endTime = Date.now();
        const elapsedTime = endTime - startTime;
        console.log(
          `Series ${index + 1} (modality: ${
            item[1]
          }): Load Time = ${elapsedTime} ms`
        );
        return item;
      });

      // Once all promises are resolved, proceed to cleanup
      Promise.all(imagePromises)
        .then(() => {
          clearTimeout(loadingMessageTimeout);
          const message = document.getElementById("loadingMessage");
          if (message) {
            document.body.removeChild(message);
          }
          const firstImage = previewTab.querySelector("img");
          if (firstImage) {
            const ID = firstImage.dataset.value;
            const modality = firstImage.dataset.modality;
            const targetViewportId = viewportIds[0];
            this.openImageInViewport(ID, modality, targetViewportId);
          }
        })
        .catch((error) => {
          clearTimeout(loadingMessageTimeout);
          const message = document.getElementById("loadingMessage");
          if (message) {
            document.body.removeChild(message);
          }
          console.error("Error while loading images:", error);
        });

      const dragStartListener = (event) => {
        if (event.target.tagName === "IMG") {
          const transferData = [
            event.target.dataset.value,
            event.target.dataset.modality,
            event.target.dataset.description,
          ];
          event.dataTransfer.setData("text", JSON.stringify(transferData));
        }
      };

      previewTab.addEventListener("dragstart", dragStartListener);
      this.eventListeners.push({
        element: previewTab,
        type: "dragstart",
        listener: dragStartListener,
      });
    } catch (error) {
      console.error(error);
      const message = document.getElementById("loadingMessage");
      if (message) {
        document.body.removeChild(message);
      }
    }
  }



  async initializeCornerstone() {
    if (this.state.cornerstoneInitialized) return;

    await cornerstone.init();
    cornerstoneTools.init();

    // Add metadata providers
    cornerstone.metaData.addProvider(
      cornerstone.utilities.calibratedPixelSpacingMetadataProvider.get.bind(
        cornerstone.utilities.calibratedPixelSpacingMetadataProvider
      ),
      11000
    );

    cornerstone.metaData.addProvider(
      cornerstone.utilities.genericMetadataProvider.get.bind(
        cornerstone.utilities.genericMetadataProvider
      ),
      10000
    );

    const { preferSizeOverAccuracy, useNorm16Texture } =
      cornerstone.getConfiguration().rendering;

    window.cornerstone = cornerstone;
    window.cornerstoneTools = cornerstoneTools;
    // Register volume loaders
    cornerstone.volumeLoader.registerVolumeLoader(
      "cornerstoneStreamingImageVolume",
      cornerstoneStreamingImageVolumeLoader
    );
    cornerstone.volumeLoader.registerUnknownVolumeLoader(
      cornerstoneStreamingImageVolumeLoader
    );
    cornerstone.volumeLoader.registerVolumeLoader(
      "cornerstoneStreamingDynamicImageVolume",
      cornerstoneStreamingDynamicImageVolumeLoader
    );

    // Configure DICOM image loader
    cornerstoneDICOMImageLoader.external.cornerstone = cornerstone;
    cornerstoneDICOMImageLoader.external.dicomParser = dicomParser;
    cornerstoneDICOMImageLoader.configure({
      useWebWorkers: true,
       beforeSend: (xhr) => {
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa("admin:u4rad")
        );
      },
      decodeConfig: {
        convertFloatPixelDataToInt: false,
        use16BitDataType: preferSizeOverAccuracy || useNorm16Texture,
      },
    });

    let maxWebWorkers = 1;
    if (navigator.hardwareConcurrency) {
      maxWebWorkers = Math.min(navigator.hardwareConcurrency, 10);
    }

    // Web worker settings
    const config = {
      maxWebWorkers,
      startWebWorkersOnDemand: false,
      taskConfiguration: {
        decodeTask: {
          initializeCodecsOnStartup: false,
          strict: false,
        },
      },
    };

    cornerstoneDICOMImageLoader.webWorkerManager.initialize(config);

    this.setState({ cornerstoneInitialized: true });
  }

  async componentDidMount() {
    // Fetch patient data first
    const patientData = await this.fetchPatientData();

    if (!patientData) {
      console.error("Failed to fetch patient data");
      return;
    }
    console.log("Patient Data:", patientData);

    await this.fetchCurrentUser();

    try {
      // 1️⃣ Fetch current user first
      await this.fetchCurrentUser();

      // 2️⃣ Then fetch their services
      if (this.state.currentUser?.id) {
        await this.fetchServices(this.state.currentUser.id);
      } else {
        console.error("❌ No user ID found in currentUser");
      }

      await this.initializeCornerstone();

      // Use study_id from patient data instead of hardcoded value
      const studyid =
        patientData.study_id || "3c475322-dd16d05c-ceaf7688-4d64be59-57de70f0";

      // Setting cache size

      cornerstone.cache.setMaxCacheSize(3 * 1024 * 1024 * 1024); // 3 GB safe for most systems
      cornerstone.setUseSharedArrayBuffer(false);

      const elements = [
        document.getElementById("viewport1"),
        document.getElementById("viewport2"),
        document.getElementById("viewport3"),
        document.getElementById("viewport4"),
      ];

      // Create rendering engine if it doesn't exist
      if (!this.renderingEngine) {
        this.renderingEngine = new cornerstone.RenderingEngine(
          renderingEngineId
        );
      }

      // Check if tool group already exists
      this.toolGroup =
        cornerstoneTools.ToolGroupManager.getToolGroup(toolGroupId);
      if (!this.toolGroup) {
        // Create tool groups for storing all tools
        this.toolGroup =
          cornerstoneTools.ToolGroupManager.createToolGroup(toolGroupId);

        for (const [key, value] of Object.entries(Tools)) {
          cornerstoneTools.addTool(value);
          this.toolGroup.addTool(value.toolName);
        }

        // Enable tools
        this.toolGroup.setToolConfiguration(
          cornerstoneTools.StackScrollTool.toolName,
          {
            bindings: [
              {
                mouseButton: cornerstoneTools.Enums.MouseBindings.Primary,
              },
            ],
          }
        );

        // Set scroll active
        this.toolGroup.setToolActive(
          cornerstoneTools.StackScrollMouseWheelTool.toolName
        );
        this.toolGroup.setToolConfiguration(
          cornerstoneTools.CrosshairsTool.toolName,
          {
            bindings: [
              {
                mouseButton: cornerstoneTools.Enums.MouseBindings.Primary,
              },
            ],
          }
        );

        this.toolGroup.setToolConfiguration(
          cornerstoneTools.PlanarFreehandROITool.toolName,
          {
            calculateStats: true,
          }
        );
        this.toolGroup.setToolConfiguration(
          cornerstoneTools.HeightTool.toolName,
          {
            calculateStats: true,
          }
        );
      }

      // Define 4 stack viewports with viewport id, viewport type, DOM element to be used
      const first_viewport = {
        viewportId: viewportIds[0],
        type: cornerstone.Enums.ViewportType.STACK,
        element: elements[0],
      };

      const second_viewport = {
        viewportId: viewportIds[1],
        type: cornerstone.Enums.ViewportType.STACK,
        element: elements[1],
      };

      const third_viewport = {
        viewportId: viewportIds[2],
        type: cornerstone.Enums.ViewportType.STACK,
        element: elements[2],
      };

      const fourth_viewport = {
        viewportId: viewportIds[3],
        type: cornerstone.Enums.ViewportType.STACK,
        element: elements[3],
      };

      this.viewport_list = {
        first: first_viewport,
        second: second_viewport,
        third: third_viewport,
        fourth: fourth_viewport,
      };

      // Enable first_viewport, make it the previously selected viewport, set its properties, add the toolgroup
      this.renderingEngine.enableElement(first_viewport);
      this.selected_viewport = viewportIds[0];
      this.prev_selected_element = elements[0];

      const viewport = this.renderingEngine.getViewport(this.selected_viewport);
      viewport.setProperties({ rotation: 0 });

      // Add viewport to toolgroup if not already added
      this.toolGroup.addViewport(viewportIds[0], renderingEngineId);

      // Function to cache images and metadata, create volumes if needed
      if (!this.cornerstoneProcessed) {
        this.cornerstoneProcessed = true;
        this.cornerstone(studyid);
      }

      // Event listeners for viewports
      elements.forEach((item, i) => {
        // Initial event listener for stack viewport to capture image index
        const stackNewImageListener = function () {
          let currViewport = this.renderingEngine.getViewport(viewportIds[i]);
          let index = currViewport.getCurrentImageIdIndex() + 1;

          // Update image index
          let indexElem = document.getElementById(indexMap[currViewport.id]);
          if (indexElem) {
            indexElem.innerHTML = index;
          }
        }.bind(this);

        item.addEventListener(
          cornerstone.EVENTS.STACK_NEW_IMAGE,
          stackNewImageListener
        );
        this.eventListeners.push({
          element: item,
          type: cornerstone.EVENTS.STACK_NEW_IMAGE,
          listener: stackNewImageListener,
        });

        const clickListener = function () {
          // Get clicked viewport ID
          const clickedViewportId = viewportIds[i];

          if (this.selected_viewport !== clickedViewportId) {
            // Update selected viewport
            this.selected_viewport = clickedViewportId;

            // Reset border style
            if (this.prev_selected_element) {
              this.prev_selected_element.style.borderColor = "white";
            }
            item.style.borderColor = "red";
            this.prev_selected_element = item;

            // Dynamically update reference lines config
            const targetViewports = viewportIds.filter(
              (id) => id !== this.selected_viewport
            );

            this.toolGroup.setToolConfiguration(
              cornerstoneTools.ReferenceLinesTool.toolName,
              {
                sourceViewportId: this.selected_viewport,
                targetViewportIds: targetViewports,
              }
            );

            // Force render update
            this.renderingEngine.render();
          }
        }.bind(this);

        item.addEventListener("click", clickListener);
        this.eventListeners.push({
          element: item,
          type: "click",
          listener: clickListener,
        });
      });
    } catch (error) {
      console.error("Error in componentDidMount:", error);
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  }

  fetchServices = async (userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user_services/${userId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched services:", data);
        this.setState({ services: data.services || [] });
      } else {
        console.error("Failed to fetch services", response.status);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  
  toggleTool(newTool) {
    if (!this.toolGroup) {
      console.error("Tool group not initialized");
      return;
    }

    const tool = Tools[newTool]?.toolName;
    if (!tool) {
      console.error(`Tool ${newTool} not found`);
      return;
    }

    // 🧠 Tools that should NEVER be completely disabled
    const alwaysActiveTools = [
      "Length",
      "Angle",
      "CobbAngle",
      "RectangleROI",
      "CircleROI",
      "EllipticalROI",
      "FreehandROI",
      "Bidirectional",
      "StackScroll",
    ];

    // 🔁 SAME TOOL CLICKED AGAIN → TOGGLE OFF
    if (this.curr_tool === tool) {
      try {
        // 🔥 IMPORTANT: Crosshairs must be DISABLED, not passive
        this.toolGroup.setToolDisabled(tool);
      } catch (err) {
        console.warn("Failed to disable tool:", tool, err);
      }

      this.curr_tool = null;
      return;
    }

    // 🧹 Deactivate previous tool
    if (this.curr_tool) {
      try {
        // Crosshairs needs disable, others can go passive
        if (this.curr_tool === Tools.Crosshairs?.toolName) {
          this.toolGroup.setToolDisabled(this.curr_tool);
        } else {
          this.toolGroup.setToolPassive(this.curr_tool);
        }
      } catch (err) {
        console.warn("Failed to deactivate tool:", this.curr_tool, err);
      }
    }

    // 🛑 Disable all non-essential tools
    Object.entries(Tools).forEach(([name, t]) => {
      if (alwaysActiveTools.includes(name)) return;
      if (t.toolName !== tool) {
        try {
          this.toolGroup.setToolDisabled(t.toolName);
        } catch {}
      }
    });

    // 🎯 Activate selected tool
    this.toolGroup.setToolActive(tool, {
      bindings: [
        {
          mouseButton: cornerstoneTools.Enums.MouseBindings.Primary,
        },
      ],
    });

    this.curr_tool = tool;
  }

  volumeOrientation(event, id) {
    if (!this.renderingEngine) {
      console.error("Rendering engine not initialized");
      return;
    }

    const call = event.target.value;
    const viewport = this.renderingEngine.getViewport(id);

    if (!viewport) {
      console.error(`Viewport ${id} not found`);
      return;
    }

    switch (call) {
      case "axial":
        viewport.setOrientation(cornerstone.Enums.OrientationAxis.AXIAL);
        break;

      case "sagittal":
        viewport.setOrientation(cornerstone.Enums.OrientationAxis.SAGITTAL);
        break;

      case "coronal":
        viewport.setOrientation(cornerstone.Enums.OrientationAxis.CORONAL);
        break;
    }

    event.target.value = "";
  }

  slabThickness(val, id) {
    if (!this.renderingEngine) {
      console.error("Rendering engine not initialized");
      return;
    }

    const viewport = this.renderingEngine.getViewport(id);
    if (!viewport) {
      console.error("MIP: Viewport not found!");
      return;
    }

    viewport.setBlendMode(cornerstone.Enums.BlendModes.MAXIMUM_INTENSITY_BLEND);
    viewport.setProperties({ slabThickness: Number(val) });
    viewport.render();
  }

  slab(val, id) {
    if (!this.renderingEngine) {
      console.error("Rendering engine not initialized");
      return;
    }

    const viewport = this.renderingEngine.getViewport(id);
    if (!viewport) {
      console.error("MinIP: Viewport not found!");
      return;
    }

    viewport.setBlendMode(cornerstone.Enums.BlendModes.MINIMUM_INTENSITY_BLEND);
    viewport.setProperties({ slabThickness: Number(val) });
    viewport.render();
  }

  orientationSettings(event, id) {
    if (!this.renderingEngine) {
      console.error("Rendering engine not initialized");
      return;
    }

    const call = event.target.value;
    const viewport = this.renderingEngine.getViewport(id);

    if (!viewport) {
      console.error(`Viewport ${id} not found`);
      return;
    }

    const { rotation } = viewport.getProperties();

    switch (call) {
      case "Rleft":
        viewport.setProperties({ rotation: rotation - 90 });
        break;

      case "Rright":
        viewport.setProperties({ rotation: rotation + 90 });
        break;

      case "Hflip":
        const { flipHorizontal } = viewport.getCamera();
        viewport.setCamera({ flipHorizontal: !flipHorizontal });
        break;

      case "Vflip":
        const { flipVertical } = viewport.getCamera();
        viewport.setCamera({ flipVertical: !flipVertical });
        break;
    }

    viewport.render();
    event.target.value = "";
  }

  viewportSettings(call, id) {
    if (!this.renderingEngine) {
      console.error("Rendering engine not initialized");
      return;
    }

    const viewport = this.renderingEngine.getViewport(id);

    if (!viewport) {
      console.error(`Viewport ${id} not found`);
      return;
    }

    switch (call) {
      case "Reset":
        viewport.resetCamera();
        viewport.resetProperties();

        if (Tools["Length"]) {
          this.toolGroup.setToolDisabled(Tools["Length"].toolName);
        }
        break;
    }

    viewport.render();
  }

  layoutSettings(event) {
    const call = event.target.value;
    const container = document.querySelector(".viewport-div");

    const viewport2 = document.getElementById("viewport2");
    const viewport3 = document.getElementById("viewport3");
    const viewport4 = document.getElementById("viewport4");

    if (!this.prev_layout) {
      this.prev_layout = "one";
    }

    switch (call) {
      case "one":
        console.log("Switching to 1x1 layout (one)");
        if (this.prev_layout == "four") {
          console.log("Transitioning from 4 to 1 layout");
          this.renderingEngine.disableElement(viewportIds[1]);
          this.renderingEngine.disableElement(viewportIds[2]);
          this.renderingEngine.disableElement(viewportIds[3]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[2]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[3]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[1]);

          viewport2.style.display = "none";
          viewport3.style.display = "none";
          viewport4.style.display = "none";
        } else if (this.prev_layout == "three") {
          console.log("Transitioning from 3 to 1 layout");
          this.renderingEngine.disableElement(viewportIds[1]);
          this.renderingEngine.disableElement(viewportIds[2]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[1]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[2]);

          viewport2.style.display = "none";
          viewport3.style.display = "none";
        } else if (this.prev_layout == "two") {
          this.renderingEngine.disableElement(viewportIds[1]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[1]);
          viewport2.style.display = "none";
        }

        container.style.gridTemplateColumns = "none";
        container.style.gridTemplateRows = "none";
        break;

      case "two":
        console.log("Switching to 2x1 layout");
        if (this.prev_layout == "four") {
          console.log("Transitioning from 4 to 2 layout");
          this.renderingEngine.disableElement(viewportIds[2]);
          this.renderingEngine.disableElement(viewportIds[3]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[2]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[3]);

          viewport3.style.display = "none";
          viewport4.style.display = "none";
        } else if (this.prev_layout == "three") {
          this.renderingEngine.disableElement(viewportIds[2]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[2]);
          viewport3.style.display = "none";
        } else {
          console.log("Enabling viewport 2");
          this.renderingEngine.enableElement(this.viewport_list.second);
          this.toolGroup.addViewport(viewportIds[1], renderingEngineId);
          viewport2.style.display = "block";
        }

        container.style.gridTemplateColumns = "50% 50%";
        container.style.gridTemplateRows = "none";
        break;

      case "three":
        console.log("Switching to 1x3 layout");
        if (this.prev_layout == "four") {
          console.log("Transitioning from 4 to 3 layout");
          this.renderingEngine.disableElement(viewportIds[3]);
          this.toolGroup.removeViewports(renderingEngineId, viewportIds[3]);

          viewport4.style.display = "none";
        } else {
          console.log("Enabling viewports 2 and 3");
          this.renderingEngine.enableElement(this.viewport_list.second);
          this.renderingEngine.enableElement(this.viewport_list.third);
          this.toolGroup.addViewport(viewportIds[1], renderingEngineId);
          this.toolGroup.addViewport(viewportIds[2], renderingEngineId);

          viewport2.style.display = "block";
          viewport3.style.display = "block";
        }

        container.style.gridTemplateColumns = "33.33% 33.33% 33.33%";
        container.style.gridTemplateRows = "none";
        break;

      case "four":
        console.log("Switching to 2x2 layout");
        if (this.prev_layout == "one") {
          console.log("Transitioning from 1 to 4 layout");
          this.renderingEngine.enableElement(this.viewport_list.second);
          viewport2.style.display = "block";
          this.toolGroup.addViewport(viewportIds[1], renderingEngineId);
        }

        console.log("Enabling viewports 3 and 4");
        this.renderingEngine.enableElement(this.viewport_list.third);
        this.renderingEngine.enableElement(this.viewport_list.fourth);
        this.toolGroup.addViewport(viewportIds[2], renderingEngineId);
        this.toolGroup.addViewport(viewportIds[3], renderingEngineId);
        viewport3.style.display = "block";
        viewport4.style.display = "block";

        container.style.gridTemplateColumns = "50% 50%";
        container.style.gridTemplateRows = "50% 50%";
        break;
    }

    this.renderingEngine.resize(true, false);
    this.prev_layout = call;
    event.target.value = "";
  }

  windowingSettings(event, id) {
    const call = event.target.value;
    const viewport = this.renderingEngine.getViewport(id);
    let selectedWindow = "";
    let upperValue, lowerValue;

    switch (call) {
      case "Invert":
        const { invert } = viewport.getProperties();
        viewport.setProperties({ invert: !invert });
        selectedWindow = "Invert";
        upperValue = lowerValue = null; // No range for Invert
        break;

      case "Lungs":
        viewport.setProperties({ voiRange: { upper: 1050, lower: -1650 } });
        selectedWindow = "Lungs";
        upperValue = 1050;
        lowerValue = -1650;
        break;

      case "Brain":
        viewport.setProperties({ voiRange: { upper: 80, lower: 0 } });
        selectedWindow = "Brain";
        upperValue = 80;
        lowerValue = 0;
        break;

      case "Bone":
        viewport.setProperties({ voiRange: { upper: 1500, lower: -500 } });
        selectedWindow = "Bone";
        upperValue = 1500;
        lowerValue = -500;
        break;

      case "ST":
        viewport.setProperties({ voiRange: { upper: 225, lower: -125 } });
        selectedWindow = "Soft Tissue (ST)";
        upperValue = 225;
        lowerValue = -125;
        break;

      case "Abdomen":
        viewport.setProperties({ voiRange: { upper: 250, lower: -150 } });
        selectedWindow = "Abdomen";
        upperValue = 250;
        lowerValue = -150;
        break;

      case "Liver":
        viewport.setProperties({ voiRange: { upper: 150, lower: 0 } });
        selectedWindow = "Liver";
        upperValue = 150;
        lowerValue = 0;
        break;

      case "Mediastinal":
        viewport.setProperties({ voiRange: { upper: 225, lower: -125 } });
        selectedWindow = "Mediastinal";
        upperValue = 225;
        lowerValue = -125;
        break;
    }

    event.target.value = "";
    viewport.render();
  }

  toggleInvert() {
    if (!this.renderingEngine || !this.selected_viewport) {
      console.error("Rendering engine or viewport not ready");
      return;
    }

    // Get the active viewport
    const viewport = this.renderingEngine.getViewport(this.selected_viewport);
    if (!viewport) {
      console.error("Viewport not found:", this.selected_viewport);
      return;
    }

    // Toggle invert property
    const properties = viewport.getProperties();
    const newInvertState = !properties.invert;

    viewport.setProperties({
      invert: newInvertState,
    });

    // Re-render the viewport
    viewport.render();

    console.log(
      `Image inversion ${
        newInvertState ? "enabled (black↔white)" : "disabled (normal)"
      }`
    );
  }



async createTransaction() {
  try {

    const { patientData, currentUser } = this.state;

    if (!patientData) {
      console.error("No patient data found");
      return null;
    }

    const payload = {
      dicom_id: patientData.id,
      patient_name: patientData.patient_name,
      patient_id: patientData.patient_id,

      institution_name:
        patientData.institution_name ||
        patientData.InstitutionName ||
        "",

      study_description:
        patientData.study_description || "",

      no_of_views:
        patientData.imaging_views ||
        patientData.image ||
        1,

      modality:
        patientData.modality || "",

      report_date: new Date()
        .toISOString()
        .split("T")[0],

      report_time: new Date().toLocaleTimeString(
        "en-GB",
        {
          hour12: false,
        }
      ),

      reported_by:
        currentUser?.username || "",

      recived_on_db:
        patientData.recived_on_db ||
        patientData.recieved_on_db ||
        new Date().toISOString(),
    };

    console.log("🚀 FINAL TRANSACTION PAYLOAD:", payload);

    const response = await fetch(
      `https://backend.reportingbot.in/api/transaction/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();

    console.log("✅ Transaction API Response:", result);

    if (!response.ok) {
      throw new Error(
        result.error || "Transaction API failed"
      );
    }

    if (result.total_failed > 0) {
      console.error(
        "❌ Transaction Failed:",
        result.results
      );
      return null;
    }

    console.log(
      "✅ Transaction Created Successfully"
    );

    return result;

  } catch (error) {

    console.error(
      "❌ Transaction Error:",
      error
    );

    // ❌ NO ALERT HERE
    return null;
  }
}

// extractReportHeadings = (html) => {
//   if (!html) return [];

//   const wrapper = document.createElement("div");
//   wrapper.innerHTML = html;

//   // Remove demographics table(s) so the first line picked is the report heading
//   wrapper.querySelectorAll("table").forEach((t) => t.remove());

//   const blockSelector = "p, div, h1, h2, h3, h4, li";
//   const candidateEls = wrapper.querySelectorAll(blockSelector);

//   const lines = [];
//   candidateEls.forEach((el) => {
//     // Skip containers that have nested block children —
//     // only take text from the innermost block to avoid duplicates
//     if (el.querySelector(blockSelector)) return;

//     const text = (el.innerText || el.textContent || "")
//       .replace(/\s+/g, " ")
//       .trim();

//     if (text) lines.push(text);
//   });

//   if (lines.length === 0) return [];

//   const regNoPattern = /reg\.?\s*no\.?\s*[:\-]?\s*[\w/]+/i;
//   const headings = [];

//   // Heading 1: first non-empty line in the document
//   headings.push(lines[0]);

//   // Every line right after a "Reg No." line becomes a new heading
//   for (let i = 0; i < lines.length; i++) {
//     if (regNoPattern.test(lines[i])) {
//       for (let j = i + 1; j < lines.length; j++) {
//         if (lines[j].trim()) {
//           headings.push(lines[j].trim());
//           break;
//         }
//       }
//     }
//   }

//   // Preserve order, remove exact duplicates
//   return [...new Set(headings)];
// };

extractReportHeadings = (html) => {
  if (!html) return [];

  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  const headings = [];

  // Look specifically for bold text from the editor content.
  // CKEditor generally produces <strong> or <b> for bold text.
  const boldElements = wrapper.querySelectorAll("strong, b");

  boldElements.forEach((el) => {
    const text = (el.innerText || el.textContent || "")
      .replace(/\s+/g, " ")
      .trim();

    if (!text) return;

    
    const reportHeadingPattern =
      /^(MRI|MR|CT|XRAY|X-RAY|X RAY|USG|ULTRASOUND|PET|PET-CT|MAMMOGRAPHY)\b.*$/i;

    if (reportHeadingPattern.test(text)) {
      headings.push(text);
    }
  });

  // Remove exact duplicates while preserving order
  return [...new Set(headings)];
};


resolveAndSaveReportHeadings = async (htmlContent) => {
  const headings = this.extractReportHeadings(htmlContent);

  for (const heading of headings) {
    await this.saveReportHeading(heading);
  }
};

// Sends ONE heading to the backend. Backend appends it to the same
// dicom_id row (creating the row on first call, updating it after).
// saveReportHeading = async (heading) => {
//   const { patientData } = this.state;
//   if (!heading || !patientData) return;

//   try {
//     await fetch(`https://backend.reportingbot.in/api/save-report-heading/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         dicom_id: patientData.id,
//         patient_name: patientData.patient_name,
//         patient_id: patientData.patient_id,
//         report_heading: heading,
//       }),
//     });
//   } catch (err) {
//     console.error("Error saving report heading:", err);
//   }
// };

saveReportHeading = async (heading) => {
  const { patientData } = this.state;
  if (!heading || !patientData) return;

  // Save report heading only for CT, MR, PR, and SR
  const allowedModalities = ["CT", "MR", "PR", "SR"];
  const modality = (patientData.modality || "").trim().toUpperCase();

  if (!allowedModalities.includes(modality)) {
    console.log(`Skipping report heading for modality: ${modality}`);
    return;
  }

  try {
    await fetch(
      `https://backend.reportingbot.in/api/save-report-heading/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          dicom_id: patientData.id,
          patient_name: patientData.patient_name,
          patient_id: patientData.patient_id,
          report_heading: heading,
        }),
      }
    );
  } catch (err) {
    console.error("Error saving report heading:", err);
  }
};

// Extracts every heading in the finalized report and saves them
// ONE BY ONE, in order, so they all accumulate under the same dicom_id row.
resolveAndSaveReportHeadings = async (htmlContent) => {
  const headings = this.extractReportHeadings(htmlContent);
  for (const heading of headings) {
    await this.saveReportHeading(heading); // awaited sequentially, not parallel
  }
};
    downloadReportPDF = async () => {
    try {
      this.setState({ isLoading: true });
          // ✅ NEW: current user bypass flag
         const bodyPartRaw = this.state?.patientData?.body_part_examined || "";
         const skipValidation = /USA/i.test(bodyPartRaw);

      const editorContent = document.querySelector(".ck-content");
      if (!editorContent)
        return (
          alert("Editor content not found!"),
          this.setState({ isLoading: false })
        );

      let htmlContent = editorContent.innerHTML.trim();
      if (!htmlContent)
        return (
          alert("No content to export!"), this.setState({ isLoading: false })
        );

      const fixInstructions =
        "How to fix this:\n\n" +
        "1. Copy the report content you have already typed.\n" +
        "2. Go to 'Select Service'.\n" +
        "3. Select 'Blank'.\n" +
        "4. Click on 'Done'.\n" +
        "5. Paste the copied content between the Demographics table and the Signature.\n\n" +
        "Then try finalizing the report again.";

      // ------------------------------------------------------------
      // 🚫 BLOCK EXPORT IF SIGNATURE OR DEMOGRAPHICS NOT RENDERED

      const checkDiv = document.createElement("div");
      checkDiv.innerHTML = htmlContent;

      // =====================
      // SIGNATURE CHECK
      // =====================
      const signatureImgs = checkDiv.querySelectorAll("img");
      let isSignatureRendered = false;

      signatureImgs.forEach((img) => {
        const src = img.src || "";
        const alt = img.alt || "";
        const parentText = img.parentElement?.textContent || "";

        if (
          img.classList.contains("signature") ||
          /Dr\./i.test(parentText) ||
          /signature/i.test(src) ||
          /signature/i.test(alt)
        ) {
          isSignatureRendered = true;
        }
      });

      // if (!isSignatureRendered) {
      //   alert(
      //     "⚠️ Signature is not present in the report." + fixInstructions
      //   );
      //   return this.setState({ isLoading: false });
      // }
          // ✅ MODIFIED
    if (!skipValidation && !isSignatureRendered) {
      alert(
        "⚠️ Signature is not present in the report." + fixInstructions
      );
      return this.setState({ isLoading: false });
    }


      // =====================
      // DEMOGRAPHICS CHECK
      // =====================
      const textContent = checkDiv.innerText.toLowerCase();

      const hasName = /name\s*:/i.test(textContent);
      const hasPatientId = /(patient\s*id|patient\s*no)\s*:/i.test(textContent);

      // if (!hasName || !hasPatientId) {
      //   alert(
      //     "⚠️ Demographics section is missing." + fixInstructions
      //   );
      //   return this.setState({ isLoading: false });
      // }
       // ✅ MODIFIED
    if (!skipValidation && (!hasName || !hasPatientId)) {
      alert(
        "⚠️ Demographics section is missing." + fixInstructions
      );
      return this.setState({ isLoading: false });
    }



      const dicomId = this.state?.dicomId;
      if (!dicomId)
        return (
          alert("DICOM ID not found. Please reload patient data first."),
          this.setState({ isLoading: false })
        );

      // ------------------------------------------------------------
      // Convert signature images to Base64
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      const imgs = tempDiv.querySelectorAll("img");

      for (const img of imgs) {
        const src = img.src;
        if (
          src.toLowerCase().includes("signature") ||
          src.toLowerCase().includes("sign")
        ) {
          try {
            const response = await fetch(src);
            const blob = await response.blob();
            const reader = new FileReader();

            const base64Promise = new Promise((resolve) => {
              reader.onloadend = () => resolve(reader.result);
            });

            reader.readAsDataURL(blob);
            const base64Data = await base64Promise;
            img.src = base64Data;
          } catch (err) {
            console.error("Failed to convert signature to Base64:", err);
          }
        }
      }

      htmlContent = tempDiv.innerHTML;
      // ------------------------------------------------------------
      // ⭐ UPDATE Report Time dynamically ⭐
      const now = new Date();
      const reportTime = now.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      // Replace existing Report Time or insert at top
      htmlContent = htmlContent.replace(
        /<strong>\s*Report Time:\s*<\/strong>\s*[^<]*/i,
        `<strong>Report Time:</strong> ${reportTime}`
      );

      // If Report Time not found, prepend at the top
      if (!htmlContent.toLowerCase().includes("report time:")) {
        htmlContent =
          `<p><strong>Report Time:</strong> ${reportTime}</p>` + htmlContent;
      }

      // Update CKEditor content so user sees new time
      editorContent.innerHTML = htmlContent;

      // ------------------------------------------------------------
      // STRICT CHECK: Only check inside HTML content
      const plainText = htmlContent
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .toLowerCase();

      // if (!plainText.includes("name:")) {
      //   alert(
      //     "⚠️ 'Name:' heading missing in report.\nPDF cannot be finalized."
      //   );
      //   return this.setState({ isLoading: false });
      // }

      // if (!plainText.includes("patient id:")) {
      //   alert(
      //     "⚠️ 'Patient ID:' heading missing in report.\nPDF cannot be finalized."
      //   );
      //   return this.setState({ isLoading: false });
      // }
          // ✅ MODIFIED
    if (!skipValidation && !plainText.includes("name:")) {
      alert(
        "⚠️ 'Name:' heading missing in report.\nPDF cannot be finalized."
      );
      return this.setState({ isLoading: false });
    }

    // ✅ MODIFIED
    if (!skipValidation && !plainText.includes("patient id:")) {
      alert(
        "⚠️ 'Patient ID:' heading missing in report.\nPDF cannot be finalized."
      );
      return this.setState({ isLoading: false });
    }

      const nameMatch = plainText.match(/name:\s*([a-z0-9 ._-]+)/i);
      const extractedName = nameMatch?.[1]?.trim();

      const idMatch = plainText.match(/patient id:\s*([a-z0-9 ._-]+)/i);
      const extractedId = idMatch?.[1]?.trim();

      // if (!extractedName) {
      //   alert("⚠️ Name value missing.\nPlease fill it before exporting PDF.");
      //   return this.setState({ isLoading: false });
      // }

      // if (!extractedId) {
      //   alert(
      //     "⚠️ Patient ID value missing.\nPlease fill it before exporting PDF."
      //   );
      //   return this.setState({ isLoading: false });
      // }

          // ✅ MODIFIED
    if (!skipValidation && !extractedName) {
      alert("⚠️ Name value missing.\nPlease fill it before exporting PDF.");
      return this.setState({ isLoading: false });
    }

    // ✅ MODIFIED
    if (!skipValidation && !extractedId) {
      alert(
        "⚠️ Patient ID value missing.\nPlease fill it before exporting PDF."
      );
      return this.setState({ isLoading: false });
    }

      // ------------------------------------------------------------
      // Gender, modality, lesion rules, laterality etc...

      // const text = plainText;
      // const gender = this.state?.patientData?.gender?.toLowerCase() || "";
      // const modality = this.state?.patientData?.Modality?.toLowerCase() || "";

      // const meaningful = (term) => {
      //   const negation = new RegExp(
      //     `\\b(no|without|absent|absence of)\\s+${term}\\b`,
      //     "i"
      //   );
      //   if (negation.test(text)) return false;
      //   return text.includes(term);
      // };

      // const femaleTerms = [
      //   "uterus",
      //   "ovaries",
      //   "ovary",
      //   "fallopian",
      //   "cervix",
      //   "endometrium",
      //   "corpus luteum",
      // ];
      // const maleTerms = [
      //   "prostate",
      //   "seminal vesicle",
      //   "seminal vesicles",
      //   "vas deferens",
      //   "testes",
      //   "testis",
      //   "epididymis",
      // ];

      // const hasFemale = femaleTerms.some((t) => meaningful(t));
      // const hasMale = maleTerms.some((t) => meaningful(t));

      // if (gender === "male" && hasFemale) {
      //   if (
      //     window.confirm(
      //       "Female anatomy mentioned for a Male patient.\n\nOK → Fix\nCancel → Proceed"
      //     )
      //   )
      //     return this.hideLoader();
      // }

      // if (gender === "female" && hasMale) {
      //   if (
      //     window.confirm(
      //       "Male anatomy mentioned for a Female patient.\n\nOK → Fix\nCancel → Proceed"
      //     )
      //   )
      //     return this.hideLoader();
      // }

      // if (["ct", "mri"].includes(modality)) {
      //   const lesionTerms = [
      //     "nodule",
      //     "cyst",
      //     "lesion",
      //     "mass",
      //     "carcinoma",
      //     "metastasis",
      //   ];
      //   const foundLesion = lesionTerms.some((t) => meaningful(t));

      //   const sizeRegex =
      //     /\b\d+(\.\d+)?(\s*[x×]\s*\d+(\.\d+)?){0,2}\s*(mm|cm)\b/;
      //   const hasSize = sizeRegex.test(text);
      //   const hasStatus =
      //     /(benign|malignant|indeterminate|not confirmed)/i.test(text);

      //   if (foundLesion && (!hasSize || !hasStatus)) {
      //     if (
      //       window.confirm(
      //         "Lesion detected but SIZE (mm/cm) or STATUS missing.\n\nOK → Fix\nCancel → Proceed"
      //       )
      //     )
      //       return this.hideLoader();
      //   }

      //   if (foundLesion && hasSize) {
      //     const sizeMatch = text.match(sizeRegex)?.[0] || "";
      //     if (
      //       !window.confirm(
      //         `You mentioned lesion size: "${sizeMatch}".\n\nIs this correct?`
      //       )
      //     ) {
      //       return this.hideLoader();
      //     }
      //   }
      // }

      // if (
      //   text.includes("pneumothorax") &&
      //   !/(mild|moderate|severe|\b\d+%)/i.test(text)
      // ) {
      //   if (
      //     window.confirm(
      //       "Pneumothorax detected but severity or % missing.\n\nOK → Fix\nCancel → Proceed"
      //     )
      //   )
      //     return this.hideLoader();
      // }

      // const pairedOrgans = [
      //   "lung",
      //   "kidney",
      //   "breast",
      //   "ear",
      //   "eye",
      //   "nostril",
      //   "testicle",
      //   "hip",
      //   "adrenal",
      // ];
      // const skipLaterality = [
      //   "liver",
      //   "pancreas",
      //   "spleen",
      //   "uterus",
      //   "bladder",
      //   "aorta",
      // ];

      // const missingLaterality = [];
      // pairedOrgans.forEach((part) => {
      //   if (skipLaterality.includes(part)) return;
      //   const matches = [...text.matchAll(new RegExp(`\\b${part}\\b`, "gi"))];
      //   matches.forEach((m) => {
      //     const sub = text.slice(m.index - 10, m.index + 10);
      //     if (!sub.includes("right") && !sub.includes("left"))
      //       missingLaterality.push(part);
      //   });
      // });

      // if (missingLaterality.length > 0) {
      //   if (
      //     window.confirm(
      //       `Laterality missing for: ${[...new Set(missingLaterality)].join(
      //         ", "
      //       )}\n\nOK → Fix\nCancel → Proceed`
      //     )
      //   )
      //     return this.hideLoader();
      // }

       const text = plainText.toLowerCase();
const gender = this.state?.patientData?.gender?.toLowerCase() || "";

// ================= COMMON CONFIRM =================
const okFixCancelProceed = (message) => {
  return window.confirm(`${message}\n\nOK → Fix\nCancel → Proceed`);
};

// ================= HELPER =================
const meaningful = (term) => {
  const safe = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const negation = new RegExp(
    `\\b(no|without|absent|absence of)\\s+${safe}\\b`,
    "i"
  );
  if (negation.test(text)) return false;
  return text.includes(term);
};

// ================= GENDER CHECK =================
const femaleTerms = [
  "uterus",
  "ovaries",
  "ovary",
  "fallopian",
  "cervix",
  "endometrium",
  "corpus luteum",
];

const maleTerms = [
  "prostate",
  "seminal vesicle",
  "seminal vesicles",
  "vas deferens",
  "testes",
  "testis",
  "epididymis",
];

const hasFemale = femaleTerms.some(meaningful);
const hasMale = maleTerms.some(meaningful);

if (gender === "male" && hasFemale) {
  if (okFixCancelProceed("Female anatomy mentioned for a Male patient.")) {
    return this.hideLoader();
  }
}

if (gender === "female" && hasMale) {
  if (okFixCancelProceed("Male anatomy mentioned for a Female patient.")) {
    return this.hideLoader();
  }
}

// ================= LESION CHECK =================
const lesionTerms = [
  "nodule",
  "nodules",
  "cyst",
  "lesion",
  "mass",
  "carcinoma",
  "metastasis",
];

const foundLesion = lesionTerms.some(meaningful);

const sizeRegex =
  /\b\d+(\.\d+)?(\s*[x×]\s*\d+(\.\d+)?){0,2}\s*(mm|cm)\b/;

const hasSize = sizeRegex.test(text);
const hasStatus =
  /\b(benign|malignant|indeterminate|not confirmed|suspicious|likely)\b/i.test(text);

if (foundLesion && (!hasSize || !hasStatus)) {
  if (
    okFixCancelProceed(
      "Lesion detected but SIZE (mm/cm) or STATUS missing."
    )
  ) {
    return this.hideLoader();
  }
}

if (foundLesion && hasSize) {
  const sizeMatch = text.match(sizeRegex)?.[0] || "";
  if (
    okFixCancelProceed(
      `Lesion size mentioned: "${sizeMatch}". Please verify.`
    )
  ) {
    return this.hideLoader();
  }
}

// ================= PNEUMOTHORAX =================
if (
  text.includes("pneumothorax") &&
  !/(mild|moderate|severe|\b\d+%)/i.test(text)
) {
  if (
    okFixCancelProceed(
      "Pneumothorax detected but severity or % missing."
    )
  ) {
    return this.hideLoader();
  }
}

// ================= LATERALITY =================
const pairedOrgans = [
  "lung",
  "kidney",
  "breast",
  "ear",
  "eye",
  "nostril",
  "testicle",
  "hip",
  "adrenal",
];

const skipLaterality = [
  "liver",
  "pancreas",
  "spleen",
  "uterus",
  "bladder",
  "aorta",
];

const missingLaterality = [];

pairedOrgans.forEach((part) => {
  if (skipLaterality.includes(part)) return;

  const matches = [...text.matchAll(new RegExp(`\\b${part}\\b`, "gi"))];
  matches.forEach((m) => {
    const context = text.slice(
      Math.max(0, m.index - 10),
      m.index + 10
    );

    if (!context.includes("right") && !context.includes("left")) {
      missingLaterality.push(part);
    }
  });
});

if (missingLaterality.length > 0) {
  const parts = [...new Set(missingLaterality)].join(", ");
  if (
    okFixCancelProceed(
      `Laterality missing for: ${parts}`
    )
  ) {
    return this.hideLoader();
  }
}


      // ------------------------------------------------------------
      // Send to backend
      const response = await fetch(`${API_BASE_URL}/generate-report-pdf/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ html_content: htmlContent, dicom_id: dicomId }),
      });

      if (!response.ok) throw new Error("Failed to generate PDF");

      const result = await response.json();
      console.log("PDF saved:", result.file_url);

      // alert("✅ Report finalized and saved successfully!");
      // window.history.go(-1);
      try {

  // ✅ Create transaction after final report upload
  await this.createTransaction();
  await this.resolveAndSaveReportHeadings(htmlContent);

  alert("✅ Report uploaded successfully!");

} catch (transactionError) {

  console.error("Transaction Error:", transactionError);

  // ✅ Even if transaction fails
  alert(
    "⚠️ Report uploaded successfully"
  );

} finally {

  // ✅ ALWAYS MOVE USER
  window.history.go(-1);

  // OR:
  // window.location.href = "/dashboard";
}

    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate or save PDF");
    } finally {
      this.setState({ isLoading: false });
    }
  };


  generateFrontendReport = async () => {
    try {
      // console.log("=== STARTING PDF GENERATION ===");
      
      const editor = document.querySelector(".ck-content");
      if (!editor) {
        // console.error("Editor element not found!");
        return alert("Editor not loaded!");
      }

      // ================= INSTRUCTION VALIDATION =================

      const htmlContent = editor.innerHTML;

      const fixInstructions =
        "How to fix this:\n\n" +
        "1. Copy the report content.\n" +
        "2. Go to 'Select Service'.\n" +
        "3. Select 'Blank'.\n" +
        "4. Click on 'Done'.\n" +
        "5. Paste content between Demographics table and Signature.\n\n" +
        "Then try again.";

      const checkDiv = document.createElement("div");
      checkDiv.innerHTML = htmlContent;

      // -------- SIGNATURE CHECK --------
      let hasSignature = false;

      checkDiv.querySelectorAll("img").forEach((img) => {
        const src = img.src || "";
        const alt = img.alt || "";
        const parentText = img.parentElement?.textContent || "";

        if (
          img.classList.contains("signature") ||
          /Dr\./i.test(parentText) ||
          /signature/i.test(src) ||
          /signature/i.test(alt)
        ) {
          hasSignature = true;
        }
      });

      if (!hasSignature) {
        alert("⚠️ Signature is not present.\n\n" + fixInstructions);
        return;
      }

      // -------- DEMOGRAPHICS CHECK --------
      const textContent = checkDiv.innerText.toLowerCase();

      const hasName = /name\s*:/i.test(textContent);
      const hasPatientId = /(patient\s*id|patient\s*no)\s*:/i.test(textContent);

      if (!hasName || !hasPatientId) {
        alert("⚠️ Demographics section is missing.\n\n" + fixInstructions);
        return;
      }
      
      // console.log("Editor found, content length:", editor.innerHTML.length);

      const pdf = new jsPDF("p", "pt", "a4");
      const PAGE_WIDTH = pdf.internal.pageSize.width;
      const PAGE_HEIGHT = pdf.internal.pageSize.height;
      const MARGIN_LEFT = 40;
      const MARGIN_RIGHT = 40;
      const MARGIN_TOP = 80;
      const BOTTOM_MARGIN = 80;
      const LINE_HEIGHT = 15;

      let currentYPosition = MARGIN_TOP;

      // Clone editor HTML
      const wrapper = document.createElement("div");
      wrapper.innerHTML = editor.innerHTML;
      
      // console.log("Original wrapper content preview:", wrapper.innerHTML.substring(0, 500) + "...");
      
      // --------------------------
      // DEBUG: Check for CKEditor widget elements
      // --------------------------
      // console.log("=== CHECKING FOR CKEDITOR WIDGET ELEMENTS ===");
      
      // Remove all CKEditor widget helper text and elements
      const widgetHelpers = wrapper.querySelectorAll('.ck-widget__type-around, .ck-widget__type-around__button, [data-cke-widget-id]');
      // console.log(`Found ${widgetHelpers.length} CKEditor widget helper elements`);
      
      widgetHelpers.forEach((widget, idx) => {
        console.log(`Widget ${idx + 1}:`, {
          tagName: widget.tagName,
          className: widget.className,
          innerHTML: widget.innerHTML.substring(0, 100),
          textContent: widget.textContent.substring(0, 100)
        });
        widget.remove();
      });
      
      // Remove any text nodes containing widget instructions
      const walker = document.createTreeWalker(
        wrapper,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      
      let node;
      const nodesToRemove = [];
      while (node = walker.nextNode()) {
        if (node.textContent.includes('Press Enter to type') || 
            node.textContent.includes('Shift + Enter') ||
            node.textContent.includes('widget')) {
          // console.log("Found widget instruction text:", node.textContent.trim());
          nodesToRemove.push(node);
        }
      }
      
      nodesToRemove.forEach(node => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
      
      // Also remove any empty paragraphs or divs that might contain widget text
      const allElements = wrapper.querySelectorAll('p, div, span');
      allElements.forEach(el => {
        const text = el.textContent || '';
        if (text.includes('Press Enter to type') || 
            text.includes('Shift + Enter') ||
            text.includes('widget')) {
          // console.log("Removing element with widget text:", text.trim());
          el.remove();
        }
        
        // Remove completely empty elements
        if (!text.trim() && el.children.length === 0) {
          el.remove();
        }
      });

      // console.log("=== EXTRACTING IMAGES ===");
      let signatureImage = null;
      const otherImages = [];

      const allImages = wrapper.querySelectorAll("img");
      // console.log(`Found ${allImages.length} total images in editor`);

      allImages.forEach((img, idx) => {
        // const imgSrc = img.src || "";
        let imgSrc = img.src || "";

        // 🔥 force HTTPS (CRITICAL FIX)
        if (imgSrc.startsWith("http://")) {
          imgSrc = imgSrc.replace("http://", "https://");
        }
        const parentText = img.parentElement?.textContent || "";
        const altText = img.alt || "";
        const className = img.className || "";

        console.log(`Image ${idx + 1} Details:`, {
          src: imgSrc.substring(0, 80),
          alt: altText,
          class: className,
          parentText: parentText.substring(0, 50),
          isSignature: img.classList.contains("signature") ||
                      /Dr\./i.test(parentText) ||
                      /signature/i.test(imgSrc) ||
                      /signature/i.test(altText)
        });

        // Detect signature
        if (img.classList.contains("signature") ||
            /Dr\./i.test(parentText) ||
            /signature/i.test(imgSrc) ||
            /signature/i.test(altText)) {
          // console.log(`  ✓ Classified as SIGNATURE`);
          signatureImage = imgSrc;
        } else {
          // console.log(`  → Classified as OTHER IMAGE (X-ray/medical)`);
          const imgData = {
            src: imgSrc,
            w: parseInt(img.getAttribute("width") || 300),
            h: parseInt(img.getAttribute("height") || 300),
            alt: altText
          };
          otherImages.push(imgData);
        }
        img.remove();
      });

      // console.log(`Signature image: ${signatureImage ? 'FOUND' : 'NOT FOUND'}`);
      // console.log(`Other images count: ${otherImages.length}`);

      // --------------------------
      // Extract tables
      // --------------------------
      // console.log("=== EXTRACTING TABLES ===");
      const tables = [];
      wrapper.querySelectorAll("table").forEach((table, tableIdx) => {
        // console.log(`Processing table ${tableIdx + 1}`);
        
        let extractedRows = [...table.querySelectorAll("tr")].map((tr) =>
          [...tr.querySelectorAll("td, th")].map((td) => {
            const text = td.innerText.trim();
            // Clean widget text from table cells
            return text.replace(/Press Enter to type.*$/, '')
                      .replace(/Shift \+ Enter.*$/, '')
                      .trim();
          })
        );

        // console.log(`Table ${tableIdx + 1} raw rows:`, extractedRows);
        
        // Fix the rows to ensure 3x3 format for the patient info table
        const fixedRows = [];
        for (let r = 0; r < 3; r++) {
          let row = extractedRows[r] || [];
          let fixedRow = [];
          for (let c = 0; c < 3; c++) {
            let cellValue = row[c] || "";
            if (r === 2 && c === 2) {
              cellValue = "";
            }
            fixedRow[c] = cellValue;
          }
          fixedRows.push(fixedRow);
        }

        // console.log(`Table ${tableIdx + 1} fixed rows:`, fixedRows);
        tables.push(fixedRows);
        
        // Replace with a unique placeholder that won't conflict with text
        const placeholder = document.createTextNode(`[TABLE_${tableIdx}_PLACEHOLDER]`);
        table.replaceWith(placeholder);
      });

      // console.log(`Total tables extracted: ${tables.length}`);

      // --------------------------
      // Clean widget text from all text content
      // --------------------------
      const cleanWidgetText = (html) => {
        return html.replace(/Press Enter to type after or press Shift \+ Enter to type before the widget/g, '')
                  .replace(/Press Enter to type.*widget/g, '')
                  .replace(/Shift \+ Enter.*widget/g, '')
                  .trim();
      };

      // --------------------------
      // Split paragraphs into lines - IMPROVED VERSION
      // --------------------------
      const splitParagraphIntoLines = (element) => {
        const lines = [];
        let currentLine = "";

        const processChild = (child) => {
          if (child.nodeName === "BR") {
            if (currentLine.trim()) {
              // Clean zero-width spaces before adding line
              const cleanedLine = currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
              if (cleanedLine) {
                lines.push(cleanedLine);
              }
            }
            currentLine = "";
          } else if (child.nodeType === Node.TEXT_NODE) {
            const text = child.textContent;
            if (text.trim()) {
              currentLine += text;
            }
          } else if (["STRONG", "B"].includes(child.nodeName)) {
            // Handle bold text - wrap with BOLD tags
            const boldText = child.textContent.trim();
            if (boldText) {
              currentLine += "[BOLD]" + boldText + "[/BOLD]";
            }
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            // Recursively process child elements
            if (["P", "DIV", "SPAN", "H1", "H2", "H3", "H4", "H5", "H6"].includes(child.tagName)) {
              // For block elements, add their content
              const childLines = splitParagraphIntoLines(child);
              if (childLines.length > 0) {
                if (currentLine.trim()) {
                  // Clean zero-width spaces before adding line
                  const cleanedLine = currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
                  if (cleanedLine) {
                    lines.push(cleanedLine);
                  }
                }
                lines.push(...childLines);
                currentLine = "";
              }
            } else {
              // For inline elements, continue building the line
              Array.from(child.childNodes).forEach(grandChild => processChild(grandChild));
            }
          }
        };

        Array.from(element.childNodes).forEach(processChild);

        if (currentLine.trim()) {
          // Clean zero-width spaces before adding final line
          const cleanedLine = currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
          if (cleanedLine) {
            lines.push(cleanedLine);
          }
        }
        
        return lines.filter(line => {
          const cleaned = line.replace(/\[BOLD\]|\[\/BOLD\]/g, "").trim();
          return cleaned && 
                !cleaned.includes('Press Enter to type') && 
                !cleaned.includes('Shift + Enter') &&
                !cleaned.includes('widget');
        });
      };

      // --------------------------
      // Extract content with formatting - IMPROVED VERSION
      // --------------------------
      const extractContentWithFormatting = (htmlContent) => {
        // console.log("Extracting formatted content...");
        const tempDiv = document.createElement("div");
        // Clean widget text before processing
        tempDiv.innerHTML = cleanWidgetText(htmlContent);
        
        // Remove zero-width spaces and other invisible characters from ALL text nodes
        const walker2 = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
        const textNodes = [];
        let textNode;
        while (textNode = walker2.nextNode()) {
          textNodes.push(textNode);
        }
        textNodes.forEach(tn => {
          tn.textContent = tn.textContent.replace(/[\u200B-\u200D\uFEFF]/g, '');
        });

        let result = "";

        const processNode = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            if (text && !text.includes('Press Enter to type') && !text.includes('Shift + Enter')) {
              result += text + " ";
            }
            return;
          }
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          const tag = node.tagName.toLowerCase();
          const textContent = node.textContent || "";

          // Skip if contains widget text
          if (textContent.includes('Press Enter to type') || textContent.includes('Shift + Enter')) {
            return;
          }

          if (tag === "p" || tag === "div") {
            const lines = splitParagraphIntoLines(node);
            lines.forEach((line) => {
              if (line.trim() && !line.includes('Press Enter to type')) {
                result += line + "\n";
              }
            });
            if (lines.length > 0) {
              result += "\n";
            }
          } else if (tag === "br") {
            result += "\n";
          } else if (tag === "li") {
            // Handle bullet points
            let liText = "";
            Array.from(node.childNodes).forEach((child) => {
              if (child.nodeType === Node.TEXT_NODE) {
                liText += child.textContent;
              } else if (child.nodeType === Node.ELEMENT_NODE) {
                if (["strong", "b"].includes(child.tagName.toLowerCase())) {
                  liText += "[BOLD]" + child.textContent + "[/BOLD]";
                } else {
                  liText += child.textContent;
                }
              }
            });
            
            liText = liText.trim();
            
            // Handle bullet point formatting - if it starts with • inside [BOLD]
            if (liText.includes("[BOLD]•")) {
              // Extract the bullet and text
              const bulletMatch = liText.match(/\[BOLD\](•\s*)(.*?)\[\/BOLD\]/);
              if (bulletMatch) {
                result += "• " + (bulletMatch[2] ? "[BOLD]" + bulletMatch[2] + "[/BOLD]" : "") + "\n";
              } else {
                result += "• " + liText + "\n";
              }
            } else if (!liText.startsWith("•")) {
              result += "• " + liText + "\n";
            } else {
              result += liText + "\n";
            }
          } else if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(tag)) {
            result += "[BOLD]";
            Array.from(node.childNodes).forEach((child) => processNode(child));
            result += "[/BOLD]\n\n";
          } else if (["strong", "b"].includes(tag)) {
            result += "[BOLD]";
            Array.from(node.childNodes).forEach((child) => processNode(child));
            result += "[/BOLD]";
          } else if (tag === "table") {
            // This shouldn't happen since we replaced tables with placeholders
            result += "[TABLE_PLACEHOLDER]\n";
          } else {
            Array.from(node.childNodes).forEach((child) => processNode(child));
          }
        };

        Array.from(tempDiv.childNodes).forEach((child) => processNode(child));
        
        // Final cleanup - remove empty lines, zero-width spaces, etc.
        const cleanedResult = result
          .split('\n')
          .map(line => line.replace(/[\u200B-\u200D\uFEFF]/g, '').trim())
          .filter(line => {
            // Remove lines that are only zero-width spaces or empty
            const cleanLine = line.replace(/\[BOLD\]|\[\/BOLD\]/g, '').trim();
            return cleanLine && 
                  !cleanLine.includes('Press Enter to type') && 
                  !cleanLine.includes('Shift + Enter') &&
                  cleanLine !== "Blank" &&
                  cleanLine !== "⁠⁠⁠⁠⁠⁠⁠";
          })
          .join('\n')
          .replace(/\n{3,}/g, "\n\n")
          .replace(/Press Enter to type.*\n?/g, '')
          .replace(/Shift \+ Enter.*\n?/g, '')
          .replace(/^Blank$/gm, '')
          .trim();
        
        // console.log("Extracted content (first 500 chars):", cleanedResult.substring(0, 500) + "...");
        return cleanedResult;
      };

      const content = extractContentWithFormatting(wrapper.innerHTML);
      // console.log("Total content length:", content.length);

      if (!content || content.trim().length === 0) {
        // console.error("No content extracted!");
        alert("No content to generate PDF from!");
        return;
      }

      // --------------------------
      // Draw tables manually - IMPROVED
      // --------------------------
      const drawTable = (tableData, startY) => {
        // console.log(`Drawing table at Y=${startY}, table data:`, tableData);
        const cellPadding = 5;
        const rowHeight = 25;
        const tableWidth = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT;
        const numCols = tableData[0].length;
        const colWidth = tableWidth / numCols;
        let y = startY;

        // Check if we have enough space for the table
        const tableHeight = tableData.length * rowHeight;
        if (y + tableHeight > PAGE_HEIGHT - BOTTOM_MARGIN) {
          pdf.addPage();
          y = MARGIN_TOP;
          // console.log("Added new page for table");
        }

        tableData.forEach((row, rowIndex) => {
          pdf.setFont("helvetica", rowIndex === 0 ? "bold" : "normal");
          pdf.setFontSize(10);

          row.forEach((cell, colIndex) => {
            const x = MARGIN_LEFT + colIndex * colWidth;
            pdf.setDrawColor(0, 0, 0);
            pdf.setLineWidth(0.5);
            pdf.rect(x, y, colWidth, rowHeight, "S");
            
            // Clean cell text
            const cleanCell = cell.replace(/Press Enter to type.*$/, '')
                                .replace(/Shift \+ Enter.*$/, '')
                                .trim();
            const textLines = pdf.splitTextToSize(
              cleanCell,
              colWidth - cellPadding * 2
            );
            pdf.text(textLines, x + cellPadding, y + rowHeight / 2 + 3);
          });

          y += rowHeight;
        });

        // console.log(`Table drawn, returning Y=${y + 20}`);
        return y + 20;
      };

      // --------------------------
      // Preload signature image - WITH BETTER ERROR HANDLING
      // --------------------------
      let signatureImgElement = null;
      let signatureLoaded = false;
      
      if (signatureImage) {
        // console.log("Loading signature image...");
        signatureImgElement = new Image();
        signatureImgElement.crossOrigin = "anonymous";
        signatureImgElement.src = signatureImage;
        
        try {
          await new Promise((resolve, reject) => {
            signatureImgElement.onload = () => {
              // console.log("Signature loaded successfully");
              signatureLoaded = true;
              resolve();
            };
            signatureImgElement.onerror = (err) => {
              console.error("Failed to load signature:", err);
              console.error("Signature URL was:", signatureImage);
              signatureImgElement = null;
              signatureLoaded = false;
              resolve(); // Don't reject, just continue without signature
            };
          });
        } catch (err) {
          console.error("Error in signature loading promise:", err);
          signatureImgElement = null;
          signatureLoaded = false;
        }
      } else {
        // console.log("No signature image found to load");
      }

      // --------------------------
      // Preload other images with better error handling
      // --------------------------
      // console.log(`=== Loading ${otherImages.length} X-ray/medical images ===`);
      const loadedImages = new Map();

      for (let i = 0; i < otherImages.length; i++) {
        const item = otherImages[i];
        // console.log(`Loading image ${i + 1}/${otherImages.length}...`);

        const img = await new Promise((resolve) => {
          const im = new Image();
          im.crossOrigin = "anonymous";

          im.onload = () => {
            // console.log(`  ✓ Image ${i + 1} loaded successfully (${im.width}x${im.height})`);
            resolve(im);
          };

          im.onerror = (err) => {
            console.error(`  ✗ Image ${i + 1} FAILED to load:`, err);
            console.error(`    URL: ${item.src.substring(0, 100)}...`);
            resolve(null);
          };

          im.src = item.src;
        });

        if (img) {
          loadedImages.set(item.src, img);
        }
      }

      // console.log(`Successfully loaded ${loadedImages.size}/${otherImages.length} images`);

      // --------------------------
      // Function to add signature - WITH BETTER ERROR HANDLING
      // --------------------------
      const addSignature = (pdf, currentY) => {
        if (!signatureLoaded || !signatureImgElement) {
          // console.log("Signature not available or not loaded - skipping");
          return currentY;
        }

        try {
          const maxWidth = 300;
          const maxHeight = 120;

          let imgWidth = signatureImgElement.width;
          let imgHeight = signatureImgElement.height;

          const scale = Math.min(maxWidth / imgWidth, maxHeight / imgHeight, 1);
          imgWidth *= scale;
          imgHeight *= scale;

          const imgX = MARGIN_LEFT;
          let imgY = currentY;

          if (imgY + imgHeight + 10 > PAGE_HEIGHT - BOTTOM_MARGIN) {
            pdf.addPage();
            imgY = MARGIN_TOP;
            // console.log("Added new page for signature");
          }

          pdf.addImage(
            signatureImgElement,
            "PNG",
            imgX,
            imgY,
            imgWidth,
            imgHeight
          );
          // console.log(`Signature added at Y=${imgY}`);
          return imgY + imgHeight + 5;
        } catch (err) {
          console.error("Error adding signature to PDF:", err);
          return currentY;
        }
      };

      // --------------------------
      // Function to add other images - LEFT ALIGNED
      // --------------------------
      const addOtherImage = (pdf, imgSrc, currentY) => {
        // console.log(`Attempting to add X-ray image at Y=${currentY}`);

        const img = loadedImages.get(imgSrc);
        if (!img) {
          console.error("Image not found in loadedImages map!");
          return currentY;
        }

        // console.log(`  Image dimensions: ${img.width}x${img.height}`);

        // Calculate available space on current page
        const availableHeight = PAGE_HEIGHT - BOTTOM_MARGIN - currentY - 20;
        // console.log(`  Available height on page: ${availableHeight}px`);

        // Set maximum dimensions - fit width to page, height proportional
        const hasSingleImage = otherImages.length === 1;
        const multipleImages = otherImages.length > 1;
        const maxWidth = PAGE_WIDTH - 80;
        const maxHeight = multipleImages ? 220 : 280;

        // Calculate scale to fit both width and height constraints
        const widthScale = maxWidth / img.width;
        const heightScale = maxHeight / img.height;
        const scale = Math.min(widthScale, heightScale, 1);

        const finalWidth = img.width * scale;
        const finalHeight = img.height * scale;

        console.log(`  Final dimensions: ${finalWidth.toFixed(2)}x${finalHeight.toFixed(2)}`);
        // console.log(`  Scale used: ${scale.toFixed(3)}`);

        // Check if it still doesn't fit
        if (!hasSingleImage && currentY + maxHeight + 20 > PAGE_HEIGHT - BOTTOM_MARGIN) {
          pdf.addPage();
          currentY = MARGIN_TOP;
        }

        // LEFT ALIGN the image (not centered)
        const imgX = MARGIN_LEFT;
        
        try {
          pdf.addImage(img, "PNG", imgX, currentY, finalWidth, finalHeight);
          // console.log(`  ✓ Image added successfully at Y=${currentY}, X=${imgX} (LEFT ALIGNED)`);
        } catch (err) {
          console.error("  ✗ Error adding image to PDF:", err);
        }

        return currentY + finalHeight + 20;
      };

      // --------------------------
      // Check if line contains doctor name - IMPROVED
      // --------------------------
      const isDoctorLine = (line) => {
        const cleanLine = line.replace(/\[BOLD\]|\[\/BOLD\]/g, "").trim();
        const patterns = [/^Dr\./i, /^Dr\s+/i, /^Dr[A-Z]/i, /^M\.B\.B\.S/i, /^M\.D\./i, /^D\.M\.R\.D/i];
        return patterns.some((pattern) => pattern.test(cleanLine));
      };

      // --------------------------
      // Render content with tables, signature, and images - IMPROVED
      // --------------------------
      // console.log("=== STARTING PDF RENDERING ===");
      
      if (content) {
        const lines = content.split("\n");
        let tableIndex = 0;
        let signatureRendered = false;
        let imagesRendered = false;

        // console.log(`Processing ${lines.length} lines of content`);

        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          if (!line.trim()) {
            // console.log(`Skipping empty line ${i + 1}`);
            continue;
          }

          // console.log(`Processing line ${i + 1}: "${line.substring(0, 50)}..."`);

          // Check for table placeholder
          const tableMatch = line.match(/\[TABLE_(\d+)_PLACEHOLDER\]/);
          if (tableMatch && tableIndex < tables.length) {
            const tableId = parseInt(tableMatch[1]);
            // console.log(`Found TABLE placeholder ${tableId}, rendering table ${tableIndex + 1}`);
            const tableRows = tables[tableIndex];
            if (currentYPosition > PAGE_HEIGHT - BOTTOM_MARGIN - 100) {
              pdf.addPage();
              currentYPosition = MARGIN_TOP;
              // console.log("Added new page before table");
            }
            currentYPosition = drawTable(tableRows, currentYPosition);
            tableIndex++;
            
            // Remove the table placeholder from the line and continue with rest of line if any
            line = line.replace(/\[TABLE_\d+_PLACEHOLDER\]\s*/, '');
            if (!line.trim()) {
              continue;
            }
          }

          // Check if this is the doctor line and signature not yet rendered
          if (!signatureRendered && isDoctorLine(line)) {
            // console.log("Found doctor line, attempting to add signature...");
            currentYPosition += 15;
            currentYPosition = addSignature(pdf, currentYPosition);
            currentYPosition += 5;
            signatureRendered = true;
            // console.log("Signature rendering attempted");
          }

          // Render line text
          let text = line;
          let isBold = false;
          
          // Special handling for bullet points with bold formatting
          const bulletBoldMatch = text.match(/^•\s*\[BOLD\](.*?)\[\/BOLD\]$/);
          if (bulletBoldMatch) {
            // Format: "• [BOLD]text[/BOLD]"
            const bulletText = bulletBoldMatch[1];
            
            // Render bullet in normal font
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(12);
            pdf.text("•", MARGIN_LEFT, currentYPosition);
            
            // Render text in bold
            pdf.setFont("helvetica", "bold");
            const textWidth = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT - 20;
            const splitText = pdf.splitTextToSize(bulletText, textWidth);
            pdf.text(splitText, MARGIN_LEFT + 20, currentYPosition);
            
            console.log(`Bullet with bold text rendered at Y=${currentYPosition}`);
            currentYPosition += splitText.length * LINE_HEIGHT;
            continue;
          }
          text = text.replace(/(\[BOLD\])+/g, "[BOLD]").replace(/(\[\/BOLD\])+/g, "[/BOLD]");
          // Check for [BOLD] tags
            const boldMatches = text.match(/\[BOLD\](.*?)\[\/BOLD\]/g);
          if (boldMatches) {
            isBold = true;
            // Strip repeatedly in case any nesting still remains after collapsing
            let prevText;
            do {
              prevText = text;
              text = text.replace(/\[BOLD\](.*?)\[\/BOLD\]/g, "$1");
            } while (text !== prevText);
      
          }
          const isBullet = text.startsWith("•");
          if (isBullet) {
            text = text.substring(1).trim();
          }

          pdf.setFont("helvetica", isBold ? "bold" : "normal");
          pdf.setFontSize(12);

          const textWidth = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT - (isBullet ? 20 : 0);
          const splitText = pdf.splitTextToSize(text, textWidth);

          if (currentYPosition + splitText.length * LINE_HEIGHT > PAGE_HEIGHT - BOTTOM_MARGIN) {
            pdf.addPage();
            currentYPosition = MARGIN_TOP;
            // console.log("Added new page for text overflow");
          }

          if (isBullet) {
            pdf.text("•", MARGIN_LEFT, currentYPosition);
            pdf.text(splitText, MARGIN_LEFT + 20, currentYPosition);
          } else {
            pdf.text(splitText, MARGIN_LEFT, currentYPosition);
          }

          // console.log(`Text rendered at Y=${currentYPosition}, height=${splitText.length * LINE_HEIGHT}`);
          currentYPosition += splitText.length * LINE_HEIGHT;
        }

        // Add images at the end after all text content (including signature)
        if (otherImages.length > 0) {

          const hasSingleImage = otherImages.length === 1;
          const hasMultipleImages = otherImages.length > 1;

          // Rule 1: Single image → stay on first page
          if (hasSingleImage) {
            currentYPosition += 30;
          }
          
          for (let i = 0; i < otherImages.length; i++) {
            // Rule 2: Multiple images → start on second page
            if (hasMultipleImages && i === 1) {
              pdf.addPage();
              currentYPosition = MARGIN_TOP;
            }

            currentYPosition = addOtherImage(
              pdf,
              otherImages[i].src,
              currentYPosition
            );
          } 
        }
      }

      // console.log("=== PDF generation complete ===");

      // -------------------------
      // GENERATE PDF BLOB
      // -------------------------
      const pdfBlob = pdf.output("blob");
      // console.log("PDF blob created, size:", pdfBlob.size, "bytes");

      const urlParams = new URLSearchParams(window.location.search);
      const dicomId = urlParams.get("id");

      if (!dicomId) {
        alert("DICOM ID missing in URL");
        return;
      }

      const uploadUrl = `${API_BASE_URL}/upload-report/${dicomId}/`;
      const formData = new FormData();
      formData.append("report_file", pdfBlob, "report.pdf");

      // console.log("Uploading PDF to:", uploadUrl);

      // -------------------------
      // CALL BACKEND API — DIRECT UPLOAD
      // -------------------------
      try {
        const response = await fetch(uploadUrl, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        // console.log("UPLOAD RESPONSE:", result);

        if (response.ok) {
          // console.log("Report uploaded successfully!");
          // alert("Report uploaded successfully!");
          // window.history.back();
          // console.log("Presigned URL:", result.presigned_url);
               try {

      // ✅ Create transaction after final report upload
      await this.createTransaction();
      await this.resolveAndSaveReportHeadings(htmlContent);

      alert("Report uploaded  successfully!");

    } catch (transactionError) {

      console.error("Transaction Error:", transactionError);

      // ✅ Even if transaction fails
      alert(
        "Report uploaded successfully"
      );

    } finally {

      // ✅ ALWAYS MOVE USER
      window.history.back();

      // OR use:
      // window.location.href = "/dashboard";
    }

        } else {
          // console.error("Upload failed with response:", result);
          alert("Upload failed: " + JSON.stringify(result));
        }
      } catch (error) {
        // console.error("UPLOAD ERROR:", error);
        alert("Upload error — check console");
      }
    } catch (err) {
      // console.error("PDF GENERATION ERROR:", err);
      // console.error("Error stack:", err.stack);
      alert("Error generating PDF: " + err.message);
    }
  };          



FrontendTBReport = async () => {
  try {
    const editor = document.querySelector(".ck-content");
    if (!editor) return alert("Editor not loaded!");

    // ================= INSTRUCTION VALIDATION =================

      const htmlContent = editor.innerHTML;

      const fixInstructions =
        "How to fix this:\n\n" +
        "1. Copy the report content.\n" +
        "2. Go to 'Select Service'.\n" +
        "3. Select 'Blank'.\n" +
        "4. Click on 'Done'.\n" +
        "5. Paste content between Demographics table and Signature.\n\n" +
        "Then try again.";

      const checkDiv = document.createElement("div");
      checkDiv.innerHTML = htmlContent;

      // -------- SIGNATURE CHECK --------
      let hasSignature = false;

      checkDiv.querySelectorAll("img").forEach((img) => {
        const src = img.src || "";
        const alt = img.alt || "";
        const parentText = img.parentElement?.textContent || "";

        if (
          img.classList.contains("signature") ||
          /Dr\./i.test(parentText) ||
          /signature/i.test(src) ||
          /signature/i.test(alt)
        ) {
          hasSignature = true;
        }
      });

      if (!hasSignature) {
        alert("⚠️ Signature is not present.\n\n" + fixInstructions);
        return;
      }

      // -------- DEMOGRAPHICS CHECK --------
      const textContent = checkDiv.innerText.toLowerCase();

      const hasName = /name\s*:/i.test(textContent);
      const hasPatientId = /(patient\s*id|patient\s*no)\s*:/i.test(textContent);

      if (!hasName || !hasPatientId) {
        alert("⚠️ Demographics section is missing.\n\n" + fixInstructions);
        return;
      }

    const pdf = new jsPDF("p", "pt", "a4");
    const PAGE_WIDTH = pdf.internal.pageSize.width;
    const PAGE_HEIGHT = pdf.internal.pageSize.height;
    const MARGIN_LEFT = 40;
    const MARGIN_RIGHT = 40;
    const MARGIN_TOP = 80;
    const BOTTOM_MARGIN = 80;
    const LINE_HEIGHT = 15;

    let currentYPosition = MARGIN_TOP;

    // --------------------------
    // Clone editor HTML for text extraction
    // --------------------------
    const wrapper = document.createElement("div");
    wrapper.innerHTML = editor.innerHTML;

    // Remove CKEditor helper elements
    wrapper.querySelectorAll('.ck-widget__type-around, .ck-widget__type-around__button, [data-cke-widget-id]')
      .forEach(el => el.remove());

    // Remove placeholder text nodes
    const walker = document.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT, null, false);
    let node;
    const nodesToRemove = [];
    while (node = walker.nextNode()) {
      if (node.textContent.includes('Press Enter to type') || node.textContent.includes('Shift + Enter') || node.textContent.includes('widget')) {
        nodesToRemove.push(node);
      }
    }
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements
    wrapper.querySelectorAll('p, div, span').forEach(el => {
      const text = el.textContent || '';
      if (!text.trim() && el.children.length === 0) el.remove();
    });

    // --------------------------
    // Extract tables
    // --------------------------
    const tables = [];
    wrapper.querySelectorAll("table").forEach((table, tableIdx) => {
      let extractedRows = [...table.querySelectorAll("tr")].map(tr =>
        [...tr.querySelectorAll("td, th")].map(td =>
          td.innerText.trim().replace(/Press Enter to type.*$/, '').replace(/Shift \+ Enter.*$/, '').trim()
        )
      );

      // Fix 3x3 format for patient info tables
      const fixedRows = [];
      for (let r = 0; r < 3; r++) {
        let row = extractedRows[r] || [];
        let fixedRow = [];
        for (let c = 0; c < 3; c++) {
          fixedRow[c] = (r === 2 && c === 2) ? "" : (row[c] || "");
        }
        fixedRows.push(fixedRow);
      }

      tables.push(fixedRows);
      const placeholder = document.createTextNode(`[TABLE_${tableIdx}_PLACEHOLDER]`);
      table.replaceWith(placeholder);
    });

    // --------------------------
    // Text extraction helpers
    // --------------------------
    const cleanWidgetText = (html) => html.replace(/Press Enter to type.*widget/g, '').replace(/Shift \+ Enter.*widget/g, '').trim();

    const splitParagraphIntoLines = (element) => {
      const lines = [];
      let currentLine = "";
      const processChild = (child) => {
        if (child.nodeName === "BR") {
          if (currentLine.trim()) lines.push(currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim());
          currentLine = "";
        } else if (child.nodeType === Node.TEXT_NODE) currentLine += child.textContent;
        else if (["STRONG", "B"].includes(child.nodeName)) currentLine += "[BOLD]" + child.textContent.trim() + "[/BOLD]";
        else if (child.nodeType === Node.ELEMENT_NODE) {
          if (["P","DIV","SPAN","H1","H2","H3","H4","H5","H6"].includes(child.tagName)) {
            const childLines = splitParagraphIntoLines(child);
            if (currentLine.trim()) lines.push(currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim());
            lines.push(...childLines);
            currentLine = "";
          } else Array.from(child.childNodes).forEach(processChild);
        }
      };
      Array.from(element.childNodes).forEach(processChild);
      if (currentLine.trim()) lines.push(currentLine.replace(/[\u200B-\u200D\uFEFF]/g, '').trim());
      return lines.filter(line => {
        const cleaned = line.replace(/\[BOLD\]|\[\/BOLD\]/g, "").trim();
        return cleaned && !cleaned.includes('Press Enter to type') && !cleaned.includes('Shift + Enter') && !cleaned.includes('widget');
      });
    };

    const extractContentWithFormatting = (htmlContent) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = cleanWidgetText(htmlContent);
      const walker2 = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
      let textNode;
      while (textNode = walker2.nextNode()) textNode.textContent = textNode.textContent.replace(/[\u200B-\u200D\uFEFF]/g, '');
      let result = "";
      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) { if(node.textContent.trim()) result += node.textContent.trim() + " "; return; }
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const tag = node.tagName.toLowerCase();
        if (tag === "p" || tag === "div") {
          const lines = splitParagraphIntoLines(node);
          lines.forEach(line => result += line + "\n");
          result += "\n";
        } else if (tag === "br") result += "\n";
        else if (tag === "li") result += "• " + node.textContent.trim() + "\n";
        else Array.from(node.childNodes).forEach(processNode);
      };
      Array.from(tempDiv.childNodes).forEach(processNode);
      return result.split('\n').map(line => line.trim()).filter(Boolean).join('\n');
    };

    const content = extractContentWithFormatting(wrapper.innerHTML);
    if (!content) return alert("No content to generate PDF!");

    // --------------------------
    // Draw table helper
    // --------------------------
    const drawTable = (tableData, startY) => {
      const cellPadding = 5;
      const rowHeight = 25;
      const tableWidth = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT;
      const numCols = tableData[0].length;
      const colWidth = tableWidth / numCols;
      let y = startY;

      const tableHeight = tableData.length * rowHeight;
      if (y + tableHeight > PAGE_HEIGHT - BOTTOM_MARGIN) { pdf.addPage(); y = MARGIN_TOP; }

      tableData.forEach((row, rowIndex) => {
        pdf.setFont("helvetica", rowIndex === 0 ? "bold" : "normal");
        pdf.setFontSize(10);
        row.forEach((cell, colIndex) => {
          const x = MARGIN_LEFT + colIndex * colWidth;
          pdf.rect(x, y, colWidth, rowHeight, "S");
          const textLines = pdf.splitTextToSize(cell, colWidth - cellPadding * 2);
          pdf.text(textLines, x + cellPadding, y + rowHeight / 2 + 3);
        });
        y += rowHeight;
      });

      return y + 20;
    };

    // --------------------------
    // Extract signature from editor
    // --------------------------
    let signatureImage = null;
    const editorImages = wrapper.querySelectorAll("img");
    editorImages.forEach((img) => {
      // const imgSrc = img.src || "";
      let imgSrc = img.src || "";

      // 🔥 force HTTPS (CRITICAL FIX)
      if (imgSrc.startsWith("http://")) {
        imgSrc = imgSrc.replace("http://", "https://");
      }
      const parentText = img.parentElement?.textContent || "";
      const altText = img.alt || "";
      if (img.classList.contains("signature") || /Dr\./i.test(parentText) || /signature/i.test(imgSrc) || /signature/i.test(altText)) {
        signatureImage = imgSrc;
      }
      img.remove();
    });

    // --------------------------
    // Load other images from previewTab
    // --------------------------
    const otherImages = [];
    const previewTab = document.getElementById("previewTab");
    if (previewTab) {
      previewTab.querySelectorAll("img").forEach(img => {
        if (img.src !== signatureImage) {
          otherImages.push({ src: img.src, w: img.clientWidth || 300, h: img.clientHeight || 300 });
        }
      });
    }

    // --------------------------
    // Preload signature
    // --------------------------
    let signatureImgElement = null;
    let signatureLoaded = false;
    if (signatureImage) {
      signatureImgElement = new Image();
      signatureImgElement.crossOrigin = "anonymous";
      signatureImgElement.src = signatureImage;
      await new Promise(resolve => {
        signatureImgElement.onload = () => { signatureLoaded = true; resolve(); };
        signatureImgElement.onerror = () => resolve();
      });
    }

    const addSignature = (pdf, currentY) => {
      if (!signatureLoaded || !signatureImgElement) return currentY;
      const maxWidth = 300, maxHeight = 120;
      let imgWidth = signatureImgElement.width;
      let imgHeight = signatureImgElement.height;
      const scale = Math.min(maxWidth / imgWidth, maxHeight / imgHeight, 1);
      imgWidth *= scale;
      imgHeight *= scale;
      if (currentY + imgHeight + 10 > PAGE_HEIGHT - BOTTOM_MARGIN) { pdf.addPage(); currentY = MARGIN_TOP; }
      pdf.addImage(signatureImgElement, "PNG", MARGIN_LEFT, currentY, imgWidth, imgHeight);
      return currentY + imgHeight + 5;
    };

    const isDoctorLine = (line) => {
      return [/^Dr\./i, /^Dr\s+/i, /^M\.B\.B\.S/i, /^M\.D\./i, /^D\.M\.R\.D/i].some(rx => rx.test(line.replace(/\[BOLD\]|\[\/BOLD\]/g, "")));
    };

    // --------------------------
    // Render text + tables + signature
    // --------------------------
    const lines = content.split("\n");
    let tableIndex = 0;
    let signatureRendered = false;

    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      if (!line.trim()) continue;

      // Table
      const tableMatch = line.match(/\[TABLE_(\d+)_PLACEHOLDER\]/);
      if (tableMatch && tableIndex < tables.length) {
        const tableRows = tables[tableIndex];
        if (currentYPosition > PAGE_HEIGHT - BOTTOM_MARGIN - 100) { pdf.addPage(); currentYPosition = MARGIN_TOP; }
        currentYPosition = drawTable(tableRows, currentYPosition);
        tableIndex++;
        line = line.replace(/\[TABLE_\d+_PLACEHOLDER\]\s*/, '');
        if (!line.trim()) continue;
      }

      // Signature inline
      if (!signatureRendered && isDoctorLine(line)) {
        currentYPosition += 15;
        currentYPosition = addSignature(pdf, currentYPosition);
        currentYPosition += 5;
        signatureRendered = true;
      }

      // Bold & bullet
      let isBold = false;
      if (line.includes("[BOLD]")) { isBold = true; line = line.replace(/\[BOLD\](.*?)\[\/BOLD\]/g, "$1"); }
      const isBullet = line.startsWith("•");
      if (isBullet) line = line.substring(1).trim();

      pdf.setFont("helvetica", isBold ? "bold" : "normal");
      pdf.setFontSize(12);
      const textWidth = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT - (isBullet ? 20 : 0);
      const splitText = pdf.splitTextToSize(line, textWidth);
      if (currentYPosition + splitText.length * LINE_HEIGHT > PAGE_HEIGHT - BOTTOM_MARGIN) { pdf.addPage(); currentYPosition = MARGIN_TOP; }
      if (isBullet) { pdf.text("•", MARGIN_LEFT, currentYPosition); pdf.text(splitText, MARGIN_LEFT + 20, currentYPosition); }
      else pdf.text(splitText, MARGIN_LEFT, currentYPosition);
      currentYPosition += splitText.length * LINE_HEIGHT;
    }

    // --------------------------
    // Preload other images
    // --------------------------
    const loadedImages = new Map();
    for (let i = 0; i < otherImages.length; i++) {
      const item = otherImages[i];
      const img = await new Promise(resolve => {
        const im = new Image();
        im.crossOrigin = "anonymous";
        im.onload = () => resolve(im);
        im.onerror = () => resolve(null);
        im.src = item.src;
      });
      if (img) loadedImages.set(item.src, img);
    }

    // --------------------------
    // Add other previewTab images at the end
    // --------------------------
    for (let i = 0; i < otherImages.length; i++) {
      pdf.addPage();
      const imgObj = loadedImages.get(otherImages[i].src);
      if (!imgObj) continue;

      const imgRatio = imgObj.width / imgObj.height;
      const pageRatio = PAGE_WIDTH / PAGE_HEIGHT;
      let finalWidth, finalHeight;
      if (imgRatio > pageRatio) { finalWidth = PAGE_WIDTH; finalHeight = PAGE_WIDTH / imgRatio; }
      else { finalHeight = PAGE_HEIGHT; finalWidth = PAGE_HEIGHT * imgRatio; }

      const x = (PAGE_WIDTH - finalWidth) / 2;
      const y = (PAGE_HEIGHT - finalHeight) / 2;

      pdf.addImage(imgObj, "PNG", x, y, finalWidth, finalHeight, undefined, "FAST");
    }

    // --------------------------
    // Upload PDF
    // --------------------------
    const pdfBlob = pdf.output("blob");
    const urlParams = new URLSearchParams(window.location.search);
    const dicomId = urlParams.get("id");
    if (!dicomId) return alert("DICOM ID missing in URL");

    const uploadUrl = `${API_BASE_URL}/upload-report/${dicomId}/`;
    const formData = new FormData();
    formData.append("report_file", pdfBlob, "report.pdf");

    try {
      const response = await fetch(uploadUrl, {
    method: "POST",
    body: formData,
  });

  const result = await response.json();

  if (response.ok) {

    try {

      // ✅ Create transaction after final report upload
      await this.createTransaction();

      alert("Report uploaded successfully!");

    } catch (transactionError) {

      console.error("Transaction Error:", transactionError);

      // ✅ Even if transaction fails
      alert(
        "Report uploaded successfully"
      );

    } finally {

      // // ✅ ALWAYS MOVE USER
      window.history.back();

      // OR use:
      // window.location.href = "/dashboard";
    }

  } else {

    alert("Upload failed: " + JSON.stringify(result));
  }
    } catch (error) {
      alert("Upload error — check console");
      console.error(error);
    }

  } catch (err) {
    alert("Error generating PDF: " + err.message);
    console.error(err);
  }
};

  closeReportEditor = () => {
    this.setState({ showReportEditor: false, splitterPosition: 50 });
  };

  startResize = (e) => {
    e.preventDefault();
    this.setState({ isResizing: true });
    const handleMouseMove = (moveEvent) => {
      if (!this.state.isResizing) return;
      const container = document.querySelector(".main-content-area");
      if (!container) return;
      const containerRect = container.getBoundingClientRect();
      const newPosition =
        ((moveEvent.clientX - containerRect.left) / containerRect.width) * 100;
      const clampedPosition = Math.max(20, Math.min(80, newPosition));
      this.setState({ splitterPosition: clampedPosition });
    };
    const handleMouseUp = () => {
      this.setState({ isResizing: false });
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  handleDraftLoaded = () => {
    this.setState({ didEditorLoadDraft: true });
  };

  handleDraftFetchComplete = (exists) => {
    this.setState({
      draftFetchComplete: true,
      draftExists: exists,
      didEditorLoadDraft: exists ? true : false,
    });
  };

  waitForEditor = () => {
    return new Promise((resolve) => {
      const checkReady = () => {
        if (window.editor && window.editor.getData) {
          resolve();
        } else {
          setTimeout(checkReady, 100);
        }
      };
      checkReady();
    });
  };

  

    waitForDraftFetch = (timeoutMs = 8000) => {
  return new Promise((resolve) => {
    const start = performance.now();

    const check = () => {
      if (this.state.draftFetchComplete) {
        console.log(
          `✅ Draft resolved in ${(performance.now() - start).toFixed(0)} ms`
        );
        resolve(true);
        return;
      }

      if (performance.now() - start >= timeoutMs) {
        console.warn("⏳ Waited 8000ms → backend still not responded");
        resolve(false);
        return;
      }

      setTimeout(check, 80);
    };

    check();
  });
};



  generateReport = () => {
  // Find Blank service
  const blankService = this.state.services.find((service) =>
    service.name.toLowerCase().includes("blank")
  );

  this.setState(
    {
      showReportEditor: true,
      splitterPosition: 50,
      selectedService: blankService ? blankService.id.toString() : "",
    },
    async () => {

  
      // ---------------- EXISTING LOGIC ----------------

      if (!blankService) return;

      // Wait for CKEditor
      await this.waitForEditor();

      // Wait for draft fetch
      await this.waitForDraftFetch();

      // If draft exists → do NOT insert blank
      if (this.state.draftExists) {
        console.log("🟦 Draft exists → Not inserting blank");
        return;
      }

      const currentContent = window.editor.getData();

      const plainText = currentContent
        ? currentContent.replace(/<[^>]*>/g, "")
        : "";

      const cleanText = plainText
        .replace(/&nbsp;/g, "")
        .replace(/\s/g, "")
        .trim();

      if (cleanText === "") {
        console.log(
          "🟩 No draft + editor empty → Inserting blank demographics"
        );
        this.autoGenerateBlankDemographics();
      } else {
        console.log("🟨 No draft + editor not empty → Not inserting");
      }
    }
  );
};


// injectClinicalHistory = (html, clinicalHistory) => {
//   if (!clinicalHistory || !html) return html;

//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, "text/html");

//   let replaced = false;

//   // Loop through all paragraphs
//   doc.querySelectorAll("p").forEach((p) => {
//     const text = p.textContent || "";

//     if (!replaced && text.trim().toUpperCase().startsWith("CLINICAL HISTORY")) {
//       // Preserve bold label if present
//       const strong = p.querySelector("strong");

//       if (strong && strong.textContent.toUpperCase().includes("CLINICAL HISTORY")) {
//         p.innerHTML = `<strong>CLINICAL HISTORY:</strong> ${clinicalHistory}`;
//       } else {
//         p.textContent = `CLINICAL HISTORY: ${clinicalHistory}`;
//       }

//       replaced = true;
//     }
//   });

//   return doc.body.innerHTML;
// };


// replaceExamWithStudyDescription = (html, studyDescription) => {
//   if (!html || !studyDescription) return html;

//   // 🧼 Remove USA only
//   const cleanedStudyDescription = studyDescription
//     .replace(/\bUSA\b[\s\-:]*/gi, "")
//     .replace(/\s+/g, " ")
//     .trim();

//   console.log("🧪 Cleaned EXAM:", cleanedStudyDescription);

//   /**
//    * Matches ONLY:
//    * EXAM: <old value>
//    * OR
//    * <strong>EXAM:</strong> <old value>
//    */
//   return html.replace(
//     /(EXAM\s*:|<strong>\s*EXAM\s*:<\/strong>)\s*([^<]*)/i,
//     `$1 ${cleanedStudyDescription}`
//   );
// };





// autoGenerateBlankDemographics = async () => {
//   try {
//     console.log("🚀 autoGenerateBlankDemographics started");

//     // 1️⃣ Get patient ID
//     const urlParams = new URLSearchParams(window.location.search);
//     const patientId = urlParams.get("id");
//     if (!patientId) {
//       console.error("❌ No patient ID found");
//       return;
//     }

//     // 2️⃣ Fetch DICOM demographics
//     const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//       body: JSON.stringify({ id: patientId }),
//     });

//     if (!response.ok) throw new Error("Failed to fetch demographics");

//     const data = await response.json();
//     console.log("📄 DICOM data:", data);

//     // 3️⃣ Clinical History
//     const clinicalHistory = this.state?.patientData?.notes || "";

//     // -----------------------------
//     // 🔧 NORMALIZATION HELPERS
//     // -----------------------------
//     const normalizeText = (text = "") =>
//       text
//         .toUpperCase()
//         .replace(/\bXR\b|\bX-RAY\b/g, "")
//         // .replace(/\bLT\b/g, "LEFT")
//         // .replace(/\bRT\b/g, "RIGHT")
//         .replace(/\b(LT|L)\b/g, "LEFT")
//         .replace(/\b(RT|R)\b/g, "RIGHT")
//         .replace(/\bB\/L\b|\bBILAT\b/g, "BILATERAL")
//         .replace(/\b\d+V\b/g, "")
//         .replace(/\s+/g, " ")
//         .trim();

//     const detectSide = (text = "") => {
//       if (text.includes("LEFT")) return "LEFT";
//       if (text.includes("RIGHT")) return "RIGHT";
//       if (text.includes("BILATERAL")) return "BILATERAL";
//       return null;
//     };

//     const resolveTemplateKey = (bodyPart, studyDesc) => {
//       const bp = normalizeText(bodyPart);
//       const sd = normalizeText(studyDesc);

//       const side = detectSide(sd) || detectSide(bp);

//       // 1️⃣ BODY PART + SIDE
//       if (bp && side && BODY_PART_TEMPLATE_MAP[`${bp} ${side}`]) {
//         return `${bp} ${side}`;
//       }

//       // 2️⃣ STUDY DESCRIPTION + SIDE
//       if (side) {
//         for (const key of Object.keys(BODY_PART_TEMPLATE_MAP)) {
//           const baseKey = key.split(" ")[0];
//           if (sd.includes(baseKey)) {
//             return `${baseKey} ${side}`;
//           }
//         }
//       }

//       // 3️⃣ GENERIC BODY PART
//       if (BODY_PART_TEMPLATE_MAP[bp]) return bp;

//       return null;
//     };

//     // 🔐 USA DETECTION
//     const hasUSAKeyword = (text = "") => /\bUSA\b/i.test(text);

//     // 4️⃣ Resolve template ONLY if USA is present
//     const bodyPartRaw =
//       this.state?.patientData?.body_part_examined || "";
//     const studyDescription =
//       this.state?.patientData?.study_description || "";

//     const isUSAStudy =
//       hasUSAKeyword(bodyPartRaw) ||
//       hasUSAKeyword(studyDescription);

//     let resolvedKey = null;
//     let requiredTemplateName = null;

//     if (isUSAStudy) {
//       resolvedKey = resolveTemplateKey(
//         bodyPartRaw,
//         studyDescription
//       );

//       requiredTemplateName =
//         resolvedKey && BODY_PART_TEMPLATE_MAP[resolvedKey];
//     } else {
//       console.log("🚫 USA not found → skipping template matching");
//     }

//     console.log("🧠 Body Part:", bodyPartRaw);
//     console.log("🧠 Study Desc:", studyDescription);
//     console.log("🇺🇸 Is USA Study:", isUSAStudy);
//     console.log("🔑 Resolved Key:", resolvedKey);
//     console.log("🎯 Template:", requiredTemplateName);

//     // 5️⃣ Fetch RSNA templates (ONLY if USA + template resolved)
//     if (isUSAStudy && requiredTemplateName) {
//       const rsnaRes = await fetch(
//         `${API_BASE_URL}/rsna/templates/?user_id=${this.state.currentUser.id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (rsnaRes.ok) {
//         const rsnaData = await rsnaRes.json();
//         const rsnaTemplates = rsnaData.templates || [];

//         const matchedTemplate = rsnaTemplates.find(
//           (tpl) => tpl.name === requiredTemplateName
//         );

//         if (matchedTemplate) {
//           const tplRes = await fetch(
//             `${API_BASE_URL}/rsna/templates/${matchedTemplate.id}/?user_id=${this.state.currentUser.id}`,
//             {
//               headers: {
//                 Authorization: `Bearer ${localStorage.getItem("token")}`,
//               },
//             }
//           );

//           if (tplRes.ok) {
//             const tplData = await tplRes.json();
//             let templateHtml = tplData.template_content;
//             // 1️⃣ Replace EXAM with actual study description
//             templateHtml = this.replaceExamWithStudyDescription(
//               templateHtml,
//               studyDescription

//             );
//             templateHtml = this.injectClinicalHistory(
//               templateHtml,
//               clinicalHistory
//             );

//             window.editor?.setData(templateHtml);
//             console.log("🎉 RSNA template loaded");
//             return;
//           }
//         }
//       }
//     }

//     // 6️⃣ FALLBACK → BLANK REPORT
//     console.log("🧾 Loading blank report");

//     const formatToDDMMYYYY = (date) =>
//       `${String(date.getDate()).padStart(2, "0")}-${String(
//         date.getMonth() + 1
//       ).padStart(2, "0")}-${date.getFullYear()}`;

//     const now = new Date();

//     const frmData = {
//       NameTextFR2: data.patient_name || "",
//       IDTextFR2: data.patient_id || "",
//       AgeTextFR2: data.age || "",
//       GenderTextFR2: data.gender || "",
//       TestDateTextFR2: data.study_date || "",
//       ReportDateTextFR2: formatToDDMMYYYY(now),
//       ReferralDoctorTextFR2:
//         data.referring_doctor_name || data.referring_doctor || "",
//       ReportTimeTextFR2: now.toLocaleTimeString("en-GB"),
//     };

//     const reportHtml = generateBlankReport(
//       frmData,
//       this.state.currentUser
//     );

//     const finalHtml = this.injectClinicalHistory(
//       reportHtml,
//       clinicalHistory
//     );

//     window.editor?.setData(finalHtml);
//     console.log("✅ Blank report loaded");
//   } catch (error) {
//     console.error("❌ Error auto-generating report:", error);
//   }
// };

normalizeModality = (modality = "") => {
  const m = String(modality).toUpperCase().trim();
  if (/X[\s-]?RAY/.test(m)) return "XR";
  if (["CR", "DX", "XR", "RF"].includes(m)) return "XR";
  if (m === "CT") return "CT";
  if (["MR", "MRI"].includes(m)) return "MR";
  if (["USG"].includes(m)) return "USG";
  return null;
};
 
 
injectClinicalHistory = (html, clinicalHistory) => {
  if (!clinicalHistory || !html) return html;
 
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
 
  let replaced = false;
 
  // Loop through all paragraphs
  doc.querySelectorAll("p").forEach((p) => {
    const text = p.textContent || "";
 
    if (!replaced && text.trim().toUpperCase().startsWith("CLINICAL HISTORY")) {
      // Preserve bold label if present
      const strong = p.querySelector("strong");
 
      if (strong && strong.textContent.toUpperCase().includes("CLINICAL HISTORY")) {
        p.innerHTML = `<strong>CLINICAL HISTORY:</strong> ${clinicalHistory}`;
      } else {
        p.textContent = `CLINICAL HISTORY: ${clinicalHistory}`;
      }
 
      replaced = true;
    }
  });
 
  return doc.body.innerHTML;
};
 
 
replaceExamWithStudyDescription = (html, studyDescription) => {
  if (!html || !studyDescription) return html;
 
  // 🧼 Remove USA only
  const cleanedStudyDescription = studyDescription
    .replace(/\bUSA\b[\s\-:]*/gi, "")
    .replace(/\s+/g, " ")
    .trim();
 
  console.log("🧪 Cleaned EXAM:", cleanedStudyDescription);
 
  /**
   * Matches ONLY:
   * EXAM: <old value>
   * OR
   * <strong>EXAM:</strong> <old value>
   */
  return html.replace(
    /(EXAM\s*:|<strong>\s*EXAM\s*:<\/strong>)\s*([^<]*)/i,
    `$1 ${cleanedStudyDescription}`
  );
};
 
 
autoGenerateBlankDemographics = async () => {
  try {
    console.log("🚀 autoGenerateBlankDemographics started");
 
    // 1️⃣ Get patient ID
    const urlParams = new URLSearchParams(window.location.search);
    const patientId = urlParams.get("id");
    if (!patientId) {
      console.error("❌ No patient ID found");
      return;
    }
 
    // 2️⃣ Fetch DICOM demographics
    const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ id: patientId }),
    });
 
    if (!response.ok) throw new Error("Failed to fetch demographics");
 
    const data = await response.json();
    console.log("📄 DICOM data:", data);
 
    // 3️⃣ Clinical History
    const clinicalHistory = this.state?.patientData?.notes || "";
 
    // -----------------------------
    // 🔧 NORMALIZATION HELPERS
    // -----------------------------
    const normalizeText = (text = "") =>
      text
        .toUpperCase()
        .replace(/\bXR\b|\bX-RAY\b/g, "")
        .replace(/\b(LT|L)\b/g, "LEFT")
        .replace(/\b(RT|R)\b/g, "RIGHT")
        .replace(/\bB\/L\b|\bBILAT\b/g, "BILATERAL")
        .replace(/\b\d+V\b/g, "")
        .replace(/\s+/g, " ")
        .trim();
 
    const detectSide = (text = "") => {
      if (text.includes("LEFT")) return "LEFT";
      if (text.includes("RIGHT")) return "RIGHT";
      if (text.includes("BILATERAL")) return "BILATERAL";
      return null;
    };
 
    // Detects real dates so a study description sitting in study_date
    // is not mistaken for a date (and vice versa)
    const looksLikeDate = (v = "") =>
      /^\d{4}[-/]?\d{2}[-/]?\d{2}/.test(v) ||
      /^\d{2}[-/]\d{2}[-/]\d{4}/.test(v);
 
    const resolveTemplateKey = (templateMap, bodyPart, studyDesc) => {
      const bp = normalizeText(bodyPart);
      const sd = normalizeText(studyDesc);
 
      // 0️⃣ EXACT STUDY DESCRIPTION (e.g. "BRAIN WITHOUT CONTRAST USA")
      if (sd && templateMap[sd]) return sd;
 
      const side = detectSide(sd) || detectSide(bp);
 
      // 1️⃣ BODY PART + SIDE
      if (bp && side && templateMap[`${bp} ${side}`]) {
        return `${bp} ${side}`;
      }
 
      // 2️⃣ STUDY DESCRIPTION + SIDE
      if (side) {
        for (const key of Object.keys(templateMap)) {
          const baseKey = key.split(" ")[0];
          const candidate = `${baseKey} ${side}`;
          if (sd.includes(baseKey) && templateMap[candidate]) {
            return candidate;
          }
        }
      }
 
      // 3️⃣ GENERIC BODY PART
      if (templateMap[bp]) return bp;
 
      return null;
    };
 
    // 🔐 USA DETECTION
    const hasUSAKeyword = (text = "") => /\bUSA\b/i.test(text);
 
    // 4️⃣ Resolve modality + template map
    const bodyPartRaw =
      this.state?.patientData?.body_part_examined || "";
 
    // Study description: use study_description, but if it is empty and the
    // text landed in study_date instead, recover it from there
    const rawStudyDesc = this.state?.patientData?.study_description || "";
    const rawStudyDate = this.state?.patientData?.study_date || "";
    const studyDescription =
      rawStudyDesc ||
      (rawStudyDate && !looksLikeDate(rawStudyDate) ? rawStudyDate : "");
 
    // Modality comes from the fetchPatientData response (state.patientData)
    const modality = this.normalizeModality(
      this.state?.patientData?.modality || data?.modality || ""
    );
    const templateMap = modality ? MODALITY_TEMPLATE_MAPS[modality] : null;
 
    const isUSAStudy =
      hasUSAKeyword(bodyPartRaw) ||
      hasUSAKeyword(studyDescription);
 
    let resolvedKey = null;
    let requiredTemplateName = null;
 
    if (!templateMap) {
      console.log("🚫 Unknown/missing modality → skipping template matching");
    } else if (isUSAStudy) {
      resolvedKey = resolveTemplateKey(
        templateMap,
        bodyPartRaw,
        studyDescription
      );
 
      requiredTemplateName =
        resolvedKey && templateMap[resolvedKey];
    } else {
      console.log("🚫 USA not found → skipping template matching");
    }
 
    console.log("🩻 Modality:", modality);
    console.log("🧠 Body Part:", bodyPartRaw);
    console.log("🧠 Study Desc:", studyDescription);
    console.log("🇺🇸 Is USA Study:", isUSAStudy);
    console.log("🔑 Resolved Key:", resolvedKey);
    console.log("🎯 Template:", requiredTemplateName);
    
    
    // 5️⃣ Fetch RSNA templates (ONLY if USA + template resolved)
    if (templateMap && isUSAStudy && requiredTemplateName) {
      const rsnaRes = await fetch(
        `${API_BASE_URL}/rsna/templates/?user_id=${this.state.currentUser.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
 
      if (rsnaRes.ok) {
        const rsnaData = await rsnaRes.json();
        const rsnaTemplates = rsnaData.templates || [];
 
        const matchedTemplate = rsnaTemplates.find(
          (tpl) => tpl.name === requiredTemplateName
        );
 
        if (matchedTemplate) {
          const tplRes = await fetch(
            `${API_BASE_URL}/rsna/templates/${matchedTemplate.id}/?user_id=${this.state.currentUser.id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
 
          if (tplRes.ok) {
            const tplData = await tplRes.json();
            let templateHtml = tplData.template_content;
            console.log("📝 Template content start:", tplData.template_content?.slice(0, 200));
 
            // 1️⃣ Replace EXAM with actual study description
            templateHtml = this.replaceExamWithStudyDescription(
              templateHtml,
              studyDescription
            );
            templateHtml = this.injectClinicalHistory(
              templateHtml,
              clinicalHistory
            );
 
            window.editor?.setData(templateHtml);
            console.log("🎉 RSNA template loaded");
            return;
          }
        } else {
          console.log("⚠️ No saved template named:", requiredTemplateName);
        }
      }
    }
 
    // 6️⃣ FALLBACK → BLANK REPORT
    console.log("🧾 Loading blank report");
 
    const formatToDDMMYYYY = (date) =>
      `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;
 
    const now = new Date();
 
    const frmData = {
      NameTextFR2: data.patient_name || "",
      IDTextFR2: data.patient_id || "",
      AgeTextFR2: data.age || "",
      GenderTextFR2: data.gender || "",
      // study_date sometimes contains the study description, so only
      // use it when it really is a date
      TestDateTextFR2: looksLikeDate(data.study_date) ? data.study_date : "",
      ReportDateTextFR2: formatToDDMMYYYY(now),
      ReferralDoctorTextFR2:
        data.referring_doctor_name || data.referring_doctor || "",
      ReportTimeTextFR2: now.toLocaleTimeString("en-GB"),
    };
 
    const reportHtml = generateBlankReport(
      frmData,
      this.state.currentUser
    );
 
    const finalHtml = this.injectClinicalHistory(
      reportHtml,
      clinicalHistory
    );
 
    window.editor?.setData(finalHtml);
    console.log("✅ Blank report loaded");
  } catch (error) {
    console.error("❌ Error auto-generating report:", error);
  }
};
 

  componentDidUpdate(prevProps, prevState) {
    // ✅ When editor just opened
    if (!prevState.showReportEditor && this.state.showReportEditor) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
        if (this.splitterRef.current) {
          void this.splitterRef.current.offsetHeight;
        }
      }, 100);
    }
  }
  async getPresignedUrl(fileKey) {
    try {
      const res = await fetch(`${API_BASE_URL}/get-file-url/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ key: fileKey }),
      });

      return await res.json(); // returns { url: "https://..." }
    } catch (err) {
      console.error("Error fetching presigned URL:", err);
      return null;
    }
  }

  componentWillUnmount() {
    console.log("Component unmounting - cleaning up resources");

    // Cleanup all event listeners
    this.eventListeners.forEach(({ element, type, listener }) => {
      if (element && element.removeEventListener) {
        try {
          element.removeEventListener(type, listener);
        } catch (e) {
          console.warn("Error removing event listener:", e);
        }
      }
    });
    this.eventListeners = [];

    // Terminate web workers first
    if (
      cornerstoneDICOMImageLoader &&
      cornerstoneDICOMImageLoader.webWorkerManager
    ) {
      try {
        cornerstoneDICOMImageLoader.webWorkerManager.terminate();
      } catch (e) {
        console.warn("Error terminating web workers:", e);
      }
    }

    // Destroy tool groups
    if (cornerstoneTools && cornerstoneTools.ToolGroupManager) {
      try {
        const toolGroup =
          cornerstoneTools.ToolGroupManager.getToolGroup(toolGroupId);
        if (toolGroup) {
          toolGroup.destroy();
        }
        cornerstoneTools.ToolGroupManager.destroy();
      } catch (e) {
        console.warn("Error destroying tool groups:", e);
      }
    }

    // Destroy rendering engine
    if (this.renderingEngine) {
      try {
        this.renderingEngine.destroy();
        this.renderingEngine = null;
      } catch (e) {
        console.warn("Error destroying rendering engine:", e);
      }
    }

    // Destroy tools
    if (cornerstoneTools) {
      try {
        cornerstoneTools.destroy();
      } catch (e) {
        console.warn("Error destroying tools:", e);
      }
    }

    // Clean up volumes carefully
    if (cornerstone && cornerstone.cache) {
      try {
        // First, remove all volumes from viewports to detach them
        if (this.renderingEngine) {
          viewportIds.forEach((viewportId) => {
            try {
              const viewport = this.renderingEngine.getViewport(viewportId);
              if (viewport && viewport.setVolumes) {
                viewport.setVolumes([]);
              }
            } catch (e) {
              console.warn(`Error clearing viewport ${viewportId}:`, e);
            }
          });
        }

        // Then purge the cache
        cornerstone.cache.purgeCache();
      } catch (e) {
        console.warn("Error during cache cleanup:", e);
      }
    }

    // Reset instance variables
    this.toolGroup = null;
    this.renderingEngine = null;
    this.viewport_list = {};
    this.selected_viewport = null;
    this.prev_selected_element = null;
    this.nonCT_ImageIds = [];
    this.curr_tool = null;
    this.prev_layout = "one";
    this.cornerstoneProcessed = false;

    // Reset cornerstone initialized state
    this.setState({ cornerstoneInitialized: false });

    console.log("Cleanup completed");
  }

  render() {
    const {
      showDetails,
      status,
      showReportEditor,
      studyData,
      reportFrmData,
      splitterPosition,
      isResizing,
      loading,
      error,
      patientData,
    } = this.state;
    // Show loading state
    if (loading) {
      return (
        <div className="body">
          <div className="page-content">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading patient data...</p>
            </div>
          </div>
        </div>
      );
    }

    // Show error state
    if (error) {
      return (
        <div className="body">
          <div className="page-content">
            <div className="error-container">
              <AlertCircle className="error-icon" size={48} />
              <h2>Error Loading Patient Data</h2>
              <p>{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="retry-btn"
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Use patient data from API or fallback to defaults
    const dicomId = patientData?.id || "DICOM-XXXX-XXXX";
    const patientName = patientData?.patient_name || "Patient Name";
    const patientId = patientData?.patient_id || "MRN-XXXX-XXXX";
    const age = patientData?.age || "Age";
    const gender = patientData?.gender || "Gender";
    const studyDate = patientData?.study_date || "2024-01-15";
    const studyid = patientData?.study_id || "Study ID";
    const studyDesc = patientData?.study_description || "Study Description";
    const bodypart = patientData?.body_part_examined || "Body Part";

    return (
      <div className="body">
        <div className="page-content">
          {/* Main Content Area - Split between Viewer and Editor */}
          <div
            className={`main-content-area ${
              showReportEditor ? "split-view" : ""
            }`}
            style={
              showReportEditor
                ? {
                    display: "flex",
                    height: "calc(100vh)", // Adjust based on your header height
                    position: "relative",
                    overflow: "hidden",
                  }
                : {}
            }
          >
            {/* Cornerstone Viewer */}
            <div
              className="cornerstone-container"
              style={
                showReportEditor
                  ? {
                      width: `${splitterPosition}%`,
                      display: "flex",
                      flexDirection: "row",
                      height: "100%",
                      flexShrink: 0,
                      overflow: "hidden", // Add overflow hidden
                      minWidth: "100px", // Prevent from becoming too small
                    }
                  : {}
              }
            >
              <div className="left-panel">
                <div className="viewer-sidebar">
                  <h1 className="viewer-title">
                    <span className="white-text">U</span>
                    <span className="red-text">4</span>
                    <span className="white-text">RAD</span>
                    <span className="white-text">&nbsp;reporting platform</span>
                  </h1>

                  <div className="user-info" onClick={this.toggleDetails}>
                    <div className="user-avatar">
                      <User size={20} />
                    </div>
                    <div>
                      <h2 className="user-name">{patientName}</h2>
                      <p className="user-detail">
                        <span className="user-mrn">MRN: {patientId}</span> |{" "}
                        Age:{" "}
                        <span className="white-text">
                          {age} {gender}
                        </span>{" "}
                        | Study: <span className="white-text">{studyDate}</span>{" "}
                        | Body Part:{" "}
                        <span className="white-text">{bodypart}</span>
                      </p>
                    </div>
                  </div>

                  {showDetails && (
                    <div className="history-notes">
                      {/* NOTES */}
                      {patientData?.study_description && (
                        <div className="history-content">
                          <h3>studyDesc</h3>
                          <p className="history-text">
                            {patientData.study_description}
                          </p>
                        </div>
                      )}

                      {/* NOTES */}
                      {patientData?.notes && (
                        <div className="history-content">
                          <h3>Notes</h3>
                          <p className="history-text">{patientData.notes}</p>
                        </div>
                      )}

                      {/* --- PATIENT REPORTS --- */}
                      <div className="history-content">
                        <h3>Reports</h3>

                        <div className="flex flex-wrap gap-1 px-1 max-w-[160px] justify-end">
                          {patientData?.patient_reports?.length > 0 ? (
                            patientData.patient_reports.map((report, index) => (
                              <button
                                key={`report-${index}`}
                                className="bg-red-500 text-white px-2 py-[2px] rounded text-[11px] hover:bg-red-600"
                                onClick={async (e) => {
                                  e.stopPropagation();

                                  const fileKey = report.file_key; // <-- backend key
                                  if (!fileKey) {
                                    alert("No file key found");
                                    return;
                                  }

                                  const res = await this.getPresignedUrl(
                                    fileKey
                                  );
                                  if (res?.url) window.open(res.url, "_blank");
                                  else alert("Error opening report");
                                }}
                              >
                                {report.report_title || `Report ${index + 1}`}
                              </button>
                            ))
                          ) : (
                            <div className="text-[11px] text-gray-400">
                              No previous reports available
                            </div>
                          )}
                        </div>
                      </div>

                      {/* --- HISTORY FILES --- */}
                      {patientData?.history_files?.length > 0 && (
                        <div className="history-content">
                          <h3>History Files</h3>

                          <div className="flex flex-wrap gap-1 px-1 max-w-[160px] justify-end">
                            {patientData.history_files.map((fileKey, index) => (
                              <button
                                key={`history-${index}`}
                                onClick={async (e) => {
                                  e.stopPropagation();

                                  const res = await this.getPresignedUrl(
                                    fileKey
                                  );
                                  if (res?.url) window.open(res.url, "_blank");
                                  else alert("Error opening history file");
                                }}
                                className="border border-red-500 text-red-500 px-2 py-[2px] rounded text-[11px] hover:bg-red-50"
                              >
                                H{index + 1}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="images-section">
                    <div className="images-header">
                      <h3>Images</h3>
                    </div>
                    <div className="previewTab" id="previewTab"></div>
                  </div>
                </div>
              </div>
              {/* Sidebar */}
              <div className="viewer-panel">
                <div className="viewer-container">
                  <div className="status-bar">
                    <div className="status-items">
                      <div className="status-item">
                        {["under-reporting", "reported"].includes(status) ? (
                          <CheckCircle className="icon green" />
                        ) : (
                          <div className="dot green pulse"></div>
                        )}
                        <span
                          className={`status-text ${
                            ["under-reporting", "reported"].includes(status)
                              ? "green"
                              : "gray"
                          }`}
                        >
                          Viewing
                        </span>
                      </div>

                      <div className="divider"></div>

                      <div className="status-item">
                        {status === "reported" ? (
                          <CheckCircle className="icon green" />
                        ) : status === "under-reporting" ? (
                          <div className="dot yellow pulse"></div>
                        ) : (
                          <div className="dot gray"></div>
                        )}
                        <span
                          className={`status-text ${
                            status === "under-reporting"
                              ? "yellow"
                              : status === "reported"
                              ? "green"
                              : "gray"
                          }`}
                        >
                          Under-reporting
                        </span>
                      </div>

                      <div className="divider"></div>

                      <div className="status-item">
                        {status === "reported" ? (
                          <div className="dot yellow pulse"></div>
                        ) : (
                          <div className="dot gray"></div>
                        )}
                        <span className="status-text yellow">Reported</span>
                      </div>
                    </div>

                    <div className="actions">
                      <button
                        onClick={this.generateReport}
                        className="generate-btn"
                      >
                        Generate Report
                      </button>
                    </div>
                  </div>

                  <div className="toolbar">
                    <button
                      className="tool-btn"
                      value="Zoom"
                      onClick={(e) => this.toggleTool(e.target.value)}
                    >
                      Zoom
                    </button>
                    <button
                      className="tool-btn"
                      value="Length"
                      onClick={(e) => this.toggleTool(e.target.value)}
                    >
                      Measure
                    </button>
                    <button
                      className="tool-btn"
                      value="Eraser"
                      onClick={(e) => this.toggleTool(e.target.value)}
                    >
                      Eraser
                    </button>
                    <select
                      id="windowing"
                      className="tool-btn measurement-dropdown"
                      onChange={(e) =>
                        this.windowingSettings(e, this.selected_viewport)
                      }
                    >
                      <option value="" disabled selected hidden>
                        windowing
                      </option>
                      <option value="Invert">Invert</option>
                      <option value="Bone">Bone</option>
                      <option value="Lungs">Lungs</option>
                      <option value="Brain">Brain</option>
                      <option value="Abdomen">Abdomen</option>
                      <option value="ST">Soft Tissue</option>
                      <option value="Liver">Liver</option>
                      <option value="Mediastinal">Mediastinal</option>
                    </select>

                    <select
                      id="measurement"
                      className="tool-btn measurement-dropdown"
                      onChange={(e) => {
                        this.toggleTool(e.target.value);
                        e.target.selectedIndex = 0;
                      }}
                    >
                      <option value="" disabled defaultValue hidden>
                        Measurement ▼
                      </option>
                      <option value="Angle">Angle</option>
                      <option value="CobbAngle">Cobb Angle</option>
                      <option value="RectangleROI">Rectangle ROI</option>
                      <option value="CircleROI">Circle ROI</option>
                      <option value="EllipticalROI">Elliptical ROI</option>
                      <option value="FreehandROI">Freehand ROI</option>
                      <option value="SplineROI">Spline ROI</option>
                      <option value="Bidirectional">Bidirectional</option>
                      <option value="ArrowAnnotate">Arrow Annotate</option>
                    </select>

                    <select
                      id="mpr"
                      className="tool-btn measurement-dropdown"
                      onChange={(e) => {
                        this.volumeOrientation(e, this.selected_viewport);
                        e.target.selectedIndex = 0;
                      }}
                    >
                      <option value="" disabled defaultValue hidden>
                        MPR ▼
                      </option>
                      <option value="axial">Axial</option>
                      <option value="sagittal">Sagittal</option>
                      <option value="coronal">Coronal</option>
                    </select>

                    <select
                      id="orientation"
                      className="tool-btn measurement-dropdown"
                      defaultValue="" // 👈 this replaces `selected`
                      onChange={(e) =>
                        this.orientationSettings(e, this.selected_viewport)
                      }
                    >
                      <option value="" disabled hidden>
                        orientation
                      </option>
                      <option value="Rleft">Rotate Left</option>
                      <option value="Rright">Rotate Right</option>
                      <option value="Hflip">Horizontal Flip</option>
                      <option value="Vflip">Vertical Flip</option>
                    </select>

                    <select
                      id="layout"
                      className="tool-btn measurement-dropdown"
                      onChange={(e) => {
                        this.layoutSettings(e);
                        e.target.selectedIndex = 0;
                      }}
                    >
                      <option value="" disabled defaultValue hidden>
                        Layout▼
                      </option>
                      <option value="one">1x1</option>
                      <option value="two">1x2</option>
                      <option value="three">1x3</option>
                      <option value="four">2x2</option>
                    </select>

                    <select
                      id="measurement"
                      className="tool-btn measurement-dropdown"
                      defaultValue="" // placeholder
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "Reset") {
                          this.viewportSettings(
                            "Reset",
                            this.selected_viewport
                          );
                        } else if (value === "Invert") {
                          this.toggleInvert();
                        } else if (value === "Download") {
                          this.downloadAsJPEG(this.prev_selected_element);
                        } else if (value === "capture") {
                          this.capture(this.prev_selected_element);
                        } else {
                          this.toggleTool(value);
                        }
                        e.target.selectedIndex = 0; // reset dropdown
                      }}
                    >
                      <option value="" disabled hidden>
                        More▼
                      </option>
                      <option value="Probe">🔍 Pixel Value</option>
                      <option value="Crosshairs">➕ Crosshairs</option>
                      <option value="Reset">↩️ Reset</option>
                      <option value="Wheel">🖱️ Stack Scroll</option>
                      <option value="Contrast">☀️ Window Level</option>
                      <option value="Pan">✋ Pan</option>
                      <option value="Magnify">🔎 Magnify</option>
                      <option value="Invert">🌓 Invert</option>
                      <option value="Download">📸 Download JPEG</option>
                      <option value="capture">📷 Capture Viewport</option>
                    </select>
                    <button
                      className="tool-btn"
                      onClick={() => {
                        const studyInstanceUID =
                          (patientData && patientData.study_instance_uid) ||
                          "unknown";
                        if (studyInstanceUID) {
                          const ohifUrl = `https://pacs.reportingbot.in/ohif/viewer?StudyInstanceUIDs=${studyInstanceUID}`;
                          window.open(ohifUrl, "_blank");
                        }
                      }}
                    >
                      ohif
                    </button>
                  </div>
                </div>

                <div className="viewport-div">
                  <div
                    className="viewport"
                    id="viewport1"
                    data-value="first"
                    onDragOver={(e) => this.allowDrop(e)}
                    onDrop={(e) => this.drop(e)}
                  ></div>
                  <div
                    className="viewport"
                    id="viewport2"
                    data-value="second"
                    onDragOver={(e) => this.allowDrop(e)}
                    onDrop={(e) => this.drop(e)}
                  ></div>
                  <div
                    className="viewport"
                    id="viewport3"
                    data-value="third"
                    onDragOver={(e) => this.allowDrop(e)}
                    onDrop={(e) => this.drop(e)}
                  ></div>
                  <div
                    className="viewport"
                    id="viewport4"
                    data-value="fourth"
                    onDragOver={(e) => this.allowDrop(e)}
                    onDrop={(e) => this.drop(e)}
                  ></div>
                </div>
              </div>
            </div>

            {/* Resize Handle */}
            {showReportEditor && (
              <div
                className="resize-handle"
                style={{
                  width: "5px",
                  backgroundColor: "#ddd",
                  cursor: "col-resize",
                  flexShrink: 0,
                  zIndex: 100,
                }}
                onMouseDown={this.startResize}
              />
            )}
            {showReportEditor && (
              <div
                className="editor-container"
                style={{
                  width: `${100 - splitterPosition}%`,
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  backgroundColor: "#f9fafb",
                  borderLeft: "1px solid #ddd",
                  overflow: "hidden", // Add overflow hidden
                  minWidth: "400px", // Prevent from becoming too small
                }}
              >
                {/* Header */}
                <div
                  className="editor-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#fff",
                  }}
                >
                  <div id="report-editor-div" style={{ flex: 1 }}>
                    <ReportEditorModule
                      currentUser={this.state.currentUser}
                      editorData={this.state.reportFrmData}
                      patientData={this.state.patientData}
                      setEditorData={(data) =>
                        this.setState({ reportFrmData: data })
                      }
                      closeEditor={this.closeReportEditor}
                      onDraftLoaded={this.handleDraftLoaded}
                      onDraftFetchComplete={this.handleDraftFetchComplete}
                    />
                  </div>

                  <button
                    className="close-editor-btn"
                    onClick={this.closeReportEditor}
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      color: "#555",
                    }}
                  >
                    <X size={20} />
                  </button>
                </div>

                {/* --- Service Dropdown --- */}
                <div
                  className="service-selector"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#fff",
                  }}
                >
                  <label style={{ fontWeight: "bold" }}>Select Service:</label>
                  <select
                    value={this.state.selectedService}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedServiceObj = this.state.services.find(
                        (s) => s.id === parseInt(selectedId)
                      );

                      const serviceName =
                        selectedServiceObj?.name?.toLowerCase() || "";
                      console.log(
                        "Selected service:",
                        selectedServiceObj?.name
                      );

                      // Check if it's Blank service
                      const isBlankService = serviceName.includes("blank");

                      // 🔥 NEW: Clear editor when switching to ANY new service
                      if (window.editor) {
                        const currentContent = window.editor.getData();
                        const plainText = currentContent
                          ? currentContent.replace(/<[^>]*>/g, "")
                          : "";
                        const cleanText = plainText
                          .replace(/&nbsp;/g, "")
                          .replace(/\s/g, "")
                          .trim();

                        // Only clear if there's actual content (not already empty)
                        if (cleanText !== "") {
                          console.log(
                            "🟦 Clearing editor content for new service"
                          );
                          window.editor.setData("");
                        }
                      }

                      this.setState(
                        {
                          selectedService: selectedId,
                          showTbChestForm: serviceName.includes("tbchest"),
                          showXRayChestForm:
                            serviceName.includes("x-ray chest") ||
                            serviceName.includes("xray chest") ||
                            serviceName.includes("x-raychest") ||
                            serviceName.includes("xraychest"),
                          showXRayKneeForm:
                            serviceName.includes("x-ray knee") ||
                            serviceName.includes("xray knee") ||
                            serviceName.includes("x-rayknee") ||
                            serviceName.includes("xrayknee"),
                            // 👇 ADDED THIS NEW BLOCK FOR CT ABDOMEN 👇
                            showCtAbdomenForm:
                              serviceName.includes("ct abdomen") ||
                              serviceName.includes("ctabdomen") ||
                              serviceName.includes("abdomen ct"),
                            // 👆 END NEW BLOCK 👆

                            showCtHeadForm:
                              serviceName.includes("ct head") ||
                              serviceName.includes("cthead") ||
                              serviceName.includes("head ct"),

                            showCtPnsForm:
                              serviceName.includes("ct pns") ||
                              serviceName.includes("paranasal sinuses") ||
                              serviceName === "pns",
                          showXRayShoulderForm:
                            serviceName
                              .toLowerCase()
                              .includes("x-ray shoulder") ||
                            serviceName
                              .toLowerCase()
                              .includes("xray shoulder") ||
                            serviceName
                              .toLowerCase()
                              .includes("x-ray right-shoulder") ||
                            serviceName
                              .toLowerCase()
                              .includes("right shoulder"),
                          showXRayLeftShoulderForm:
                            serviceName
                              .toLowerCase()
                              .includes("x-ray left-shoulder") ||
                            serviceName
                              .toLowerCase()
                              .includes("xray left shoulder") ||
                            serviceName.toLowerCase().includes("left shoulder"),
                          showXRaySpineDorsalForm:
                            serviceName
                              .toLowerCase()
                              .includes("x-ray spine(dorsal)") ||
                            serviceName
                              .toLowerCase()
                              .includes("x-ray spine dorsal") ||
                            serviceName
                              .toLowerCase()
                              .includes("xray spine dorsal") ||
                            serviceName
                              .toLowerCase()
                              .includes("spine dorsal") ||
                            serviceName.toLowerCase().includes("dorsal spine"),
                          showXRaySpineForm:
                            serviceName
                              .toLowerCase()
                              .includes("x-ray spine(cervical)") ||
                            serviceName
                              .toLowerCase()
                              .includes("x-ray spine cervical") ||
                            serviceName
                              .toLowerCase()
                              .includes("xray spine cervical") ||
                            serviceName
                              .toLowerCase()
                              .includes("spine cervical") ||
                            serviceName
                              .toLowerCase()
                              .includes("cervical spine"),
                          showBlankForm: isBlankService,
                        },
                        async () => {
                          if (!isBlankService) return;

                          // Wait for CKEditor
                          await this.waitForEditor();

                          // Wait for backend draft fetch
                          await this.waitForDraftFetch();

                          // If draft exists → do NOT insert blank
                          if (this.state.draftExists) {
                            console.log(
                              "🟦 Draft exists → Not inserting blank"
                            );
                            return;
                          }

                          const currentContent = window.editor.getData();
                          const plainText = currentContent
                            ? currentContent.replace(/<[^>]*>/g, "")
                            : "";

                          const cleanText = plainText
                            .replace(/&nbsp;/g, "")
                            .replace(/\s/g, "")
                            .trim();

                          if (cleanText === "") {
                            console.log(
                              "🟩 No draft + editor empty → Inserting blank demographics"
                            );
                            this.autoGenerateBlankDemographics();
                          } else {
                            console.log(
                              "🟨 No draft + editor not empty → Not inserting"
                            );
                          }
                        }
                      );
                    }}
                  >
                    <option value="">Select Service</option>
                    {this.state.services.map((service) => (
                      <option key={service.id} value={service.id}>
                        {service.name}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-primary"
                    onClick={this.generateFrontendReport}
                    title="*Use this button if you want to add images to the report."
                    style={{
                      padding: "10px",
                      fontSize: "0.75rem",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      width: "9rem",
                    }}
                  >
                    GenerateCamp Report
                  </button>
                                    <button
  className="btn"
  onClick={this.FrontendTBReport}
  title="*Use this button if you want to add images to the report."
  style={{
    padding: "10px",
    fontSize: "0.75rem",
    borderRadius: "6px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    width: "9rem",
    backgroundColor: "#ffc107",   // ✅ Yellow
    color: "#000",                 // Black text
    border: "none",
  }}
>
  Doublepagereport
</button>
                </div>

                {/* CKEditor Section */}
                <div
                  className="document-editor"
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    overflowY: "auto",
                    backgroundColor: "#f9fafb",
                    height: "100%",
                  }}
                >
                  {/* --- Conditional TB Chest Form --- */}
                  {this.state.showTbChestForm && (
                    <TbChestForm
                      generateReport={(html) => {
                        console.log("Generated TB Chest Report:", html);
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showTbChestForm: false,
                          selectedService: "", // reset dropdown
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Chest Form --- */}
                  {this.state.showXRayChestForm && (
                    <XrayChest
                      generateReport={(html) => {
                        console.log("Generated X-Ray Chest Report:", html);
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRayChestForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Knee Form --- */}
                  {this.state.showXRayKneeForm && (
                    <XrayKnee
                      generateReport={(html) => {
                        console.log("Generated X-Ray Knee Report:", html);
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRayKneeForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Shoulder Form --- */}
                  {this.state.showXRayShoulderForm && (
                    <XRayShoulderForm
                      generateReport={(html) => {
                        console.log("Generated X-Ray Shoulder Report:", html);
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRayShoulderForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Left Shoulder Form --- */}
                  {this.state.showXRayLeftShoulderForm && (
                    <XRayLeftShoulderForm
                      generateReport={(html) => {
                        console.log(
                          "Generated X-Ray Left Shoulder Report:",
                          html
                        );
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRayLeftShoulderForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Spine (Cervical) Form --- */}
                  {this.state.showXRaySpineForm && (
                    <XRaySpineForm
                      generateReport={(html) => {
                        console.log(
                          "Generated X-Ray Spine Cervical Report:",
                          html
                        );
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRaySpineForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional X-Ray Spine (Dorsal) Form --- */}
                  {this.state.showXRaySpineDorsalForm && (
                    <XRaySpineDorsalForm
                      generateReport={(html) => {
                        console.log(
                          "Generated X-Ray Spine Dorsal Report:",
                          html
                        );
                        if (window.editor) {
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn("⚠️ CKEditor not initialized yet!");
                        }
                      }}
                      onClose={() => {
                        this.setState({
                          showXRaySpineDorsalForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                  {/* --- Conditional Blank Form --- */}
                  {this.state.showBlankForm && (
                    <BlankForm
                      generateReport={(html) => {
                        console.clear();

                        if (!window.editor) {
                          return;
                        }

                        const existingContent = window.editor.getData();
                        const plainText = existingContent
                          ? existingContent.replace(/<[^>]*>/g, "").trim()
                          : "";

                        if (plainText === "") {
                          console.log(
                            "✅ Editor is EMPTY → Injecting blank report"
                          );
                          // 🔥 Replace entire content
                          window.editor.setData(html);
                        } else {
                          console.warn(
                            "⚠️ Editor already contains content. Not overwriting."
                          );
                        }
                      }}
                      onClose={() => {
                        console.log("❌ Blank Form Closed");
                        this.setState({
                          showBlankForm: false,
                          selectedService: "",
                        });
                      }}
                      currentUser={this.state.currentUser}
                    />
                  )}

                     {/* --- Conditional CT Abdomen Form --- */}
                                    {this.state.showCtAbdomenForm && (
                                      <CtAbdomenForm
                                        generateReport={(html) => {
                                          console.log("Generated CT Abdomen Report:", html);
                                          if (window.editor) {
                                            window.editor.setData(html); // 🔥 Replace entire content
                                          } else {
                                            console.warn("⚠️ CKEditor not initialized yet!");
                                          }
                                        }}
                                        onClose={() => {
                                          this.setState({
                                            showCtAbdomenForm: false,
                                            selectedService: "",
                                          });
                                        }}
                                        currentUser={this.state.currentUser}
                                      />
                                    )}
                  
                                    {/* --- Conditional CT Head Form --- */}
                                    {this.state.showCtHeadForm && (
                                      <CtHeadForm
                                        generateReport={(html) => {
                                          console.log("Generated CT Head Report:", html);
                                          if (window.editor) window.editor.setData(html);
                                        }}
                                        onClose={() => {
                                          this.setState({ showCtHeadForm: false, selectedService: "" });
                                        }}
                                        currentUser={this.state.currentUser}
                                      />
                                    )}
                  
                                    {/* --- Conditional CT PNS Form --- */}
                                    {this.state.showCtPnsForm && (
                                      <CtPnsForm
                                        generateReport={(html) => {
                                          console.log("Generated CT PNS Report:", html);
                                          if (window.editor) window.editor.setData(html);
                                        }}
                                        onClose={() => {
                                          this.setState({ showCtPnsForm: false, selectedService: "" });
                                        }}
                                        currentUser={this.state.currentUser}
                                      />
                                    )}
                  

                  {/* Sticky Toolbar */}
                  <div
                    id="toolbar-container"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      backgroundColor: "#fff",
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "8px",
                      marginBottom: "8px",
                    }}
                  ></div>

                  {/* Scrollable CKEditor Content */}
                  <div
                    className="document-editor__editable-container"
                    style={{
                      flex: 1,
                      minHeight: "60vh",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                      padding: "12px",
                      boxSizing: "border-box",
                      overflowY: "auto",
                    }}
                  >
                    <CKEditor
                      editor={DecoupledEditor}
                      data={this.state.reportFrmData}
                      onReady={(editor) => {
                        console.log("✅ CKEditor ready", editor);

                        // ✅ Always reattach toolbar cleanly
                        const toolbarContainer =
                          document.getElementById("toolbar-container");
                        if (toolbarContainer) {
                          toolbarContainer.innerHTML = "";
                          toolbarContainer.appendChild(
                            editor.ui.view.toolbar.element
                          );
                        }

                        // ✅ Apply editor area styles
                        const editable = editor.ui.getEditableElement();
                        if (editable) {
                          editable.style.minHeight = "55vh";
                          editable.style.maxHeight = "100%";
                          editable.style.overflowY = "auto";
                          editable.style.overflowX = "hidden";
                          editable.style.padding = "12px";
                          editable.style.boxSizing = "border-box";
                          editable.style.marginTop = "200px";
                        }

                        // ✅ Store editor reference globally
                        window.editor = editor;

                        // ✅ Keep reference for cleanup
                        this.editorInstance = editor;
                        this.toolbarAttached = true;

                        editor.editing.view.focus();
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({
                          reportFrmData: data,
                          editorContent: data,
                        });
                      }}
                      config={{
                        toolbar: {
                          items: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "|",
                            "numberedList",
                            "bulletedList",
                            "|",
                            "insertTable",
                            "|",
                            "undo",
                            "redo",
                          ],
                          shouldNotGroupWhenFull: true,
                        },
                        language: "en",
                      }}
                    />
                  </div>

                  {/* Finalize Report Button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "150px",
                      marginTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    <button
                      onClick={this.downloadReportPDF}
                      disabled={this.state.isLoading}
                      style={{
                        backgroundColor: this.state.isLoading
                          ? "#ccc"
                          : "#007bff",
                        color: "#fff",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "6px",
                        cursor: this.state.isLoading
                          ? "not-allowed"
                          : "pointer",
                        fontSize: "15px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {this.state.isLoading ? (
                        <>
                          <div
                            className="spinner"
                            style={{
                              border: "2px solid #f3f3f3",
                              borderTop: "2px solid #fff",
                              borderRadius: "50%",
                              width: "16px",
                              height: "16px",
                              animation: "spin 1s linear infinite",
                            }}
                          />
                          Finalizing...
                        </>
                      ) : (
                        "✅ Finalize Report"
                      )}
                      <style>
                        {`
                          @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                          }
                        `}
                      </style>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Viewer;
